<style>
.purchase .ivu-steps-item .ivu-steps-title {
    color: #666 !important;
}
</style>
<template>
    <div class="purchase">
        <Steps
            :current="-1"
            class="bg-fff padding-top-15 padding-bottom-15"
            v-if="type === 'query'"
        >
            <Step
                v-for="val of updatestatus"
                :content="val.value"
                :title="val.label"
                :key="val.value"
            ></Step>
        </Steps>
        <vButtonGroup
            class="inbound-package"
            style="margin-bottom: 15px; margin-top: 10px"
            v-if="type == 'query'"
        >
            <vButton class="light-content" @click="addnotes('addnotes')"
                >{{
                    $t("boss.purchase.add_note", { defaultValue: "添加备注" })
                }}
            </vButton>
            <vButton
                v-if="formData.orderStatus == 'submit'"
                theme="success"
                @click="addnotes('auditingpass')"
                >{{
                    $t("boss.purchase.approved", { defaultValue: "审核通过" })
                }}</vButton
            >
            <vButton
                v-if="
                    formData.orderStatus == 'draft' ||
                    formData.orderStatus == 'auditing_refused'
                "
                theme="primary"
                @click="addnotes('submitbox')"
                >{{
                    $t("boss.purchase.submit", { defaultValue: "提交" })
                }}</vButton
            >
            <vButton
                v-if="
                    !(
                        formData.orderStatus == 'draft' ||
                        formData.orderStatus == 'submit'
                    )
                "
                theme="info"
                @click="addnotes('delivery')"
                >{{
                    $t("boss.purchase.delivery", { defaultValue: "交货" })
                }}</vButton
            >
            <vButton
                v-if="formData.orderStatus == 'auditing_pass'"
                theme="warning"
                @click="addnotes('inspection')"
                >{{
                    $t("boss.purchase.inspection", { defaultValue: "验货" })
                }}</vButton
            >
            <vButton
                v-if="
                    formData.orderStatus != 'canceled' &&
                    formData.orderStatus != 'draft'
                "
                theme="success"
                @click="addnotes('contractSignDate')"
                >{{
                    $t("boss.purchase.enter_contract_date", {
                        defaultValue: "录入合同日期",
                    })
                }}</vButton
            >
            <vButton
                v-if="
                    formData.orderStatus != 'canceled' &&
                    formData.orderStatus != 'draft'
                "
                theme="info"
                @click="addnotes('expectedInspectDate')"
                >{{
                    $t("boss.purchase.modify_the_expected", {
                        defaultValue: "修改预计验货日期",
                    })
                }}</vButton
            >
            <vButton
                v-if="formData.errorCode == 4"
                theme="primary"
                @click="reComputed"
                >{{
                    $t("boss.purchase.recalculate_theoretical", {
                        defaultValue: "重新计算理论交货日期",
                    })
                }}</vButton
            >
            <Tooltip style="margin-right: 8px">
                <vButton
                    v-if="formData.orderStatus != 'draft'"
                    theme="primary"
                    @click="addnotes('expectedDeliveryDate')"
                    >{{
                        $t("boss.purchase.latest_estimated_delivery", {
                            defaultValue: "录入最新预计交货日期",
                        })
                    }}</vButton
                >
                <div style="white-space: normal" slot="content">
                    {{
                        $t("boss.purchase.please_enter_the_latest", {
                            defaultValue:
                                "承诺交货日期如有变更，请录入最新预计交货日期",
                        })
                    }}
                </div>
            </Tooltip>
            <vButton theme="primary" @click="adddocument('headdoc')">{{
                $t("boss.purchase.add_attachment", {
                    defaultValue: "添加附件",
                })
            }}</vButton>
            <vButton
                v-if="
                    formData.orderStatus != 'canceled' &&
                    formData.orderStatus != 'draft'
                "
                theme="warning"
                @click="addnotes('expectedFinishDate')"
                >{{
                    $t("boss.purchase.modify_expected_shelf_date", {
                        defaultValue: "修改预计上架日期",
                    })
                }}</vButton
            >
            <vButton
                v-if="formData.orderStatus == 'submit'"
                theme="primary"
                @click="addnotes('cancelSubmit')"
                >{{
                    $t("boss.purchase.withdraw_submission", {
                        defaultValue: "撤回提交",
                    })
                }}</vButton
            >

            <vButton
                v-if="
                    formData.orderStatus == 'auditing_pass' &&
                    formData.inboundPlanReceiveList.length > 0
                "
                class="pull-right"
                @click="addnotes('close')"
                >{{
                    $t("boss.purchase.manually_complete_document", {
                        defaultValue: "手动完成单据",
                    })
                }}</vButton
            >
            <vButton
                v-if="formData.orderStatus == 'submit'"
                class="pull-right"
                @click="addnotes('auditingrefused')"
                >{{
                    $t("boss.purchase.review_rejected", {
                        defaultValue: "审核驳回",
                    })
                }}</vButton
            >
        </vButtonGroup>
        <compWrapper
            :title="
                $t('boss.purchase.purchase_order', { defaultValue: '采购单' })
            "
            theme="primary"
        >
            <section class="relative">
                <vForm
                    :label-width="120"
                    :model="formData"
                    class="clearfix margin-15"
                    :class="{ b2corder: type == 'query' }"
                    ref="applicateform"
                >
                    <vCol span="24" style="margin-top: -10px">
                        <div class="font-weight" style="margin-left: 30px">
                            {{
                                $t("boss.purchase.basic_information", {
                                    defaultValue: "基本信息",
                                })
                            }}
                        </div>
                        <div
                            style="
                                width: 99%;
                                margin-left: 15px;
                                margin-bottom: 15px;
                                font-weight: bold;
                                border-bottom: 1px solid #eae7e7;
                            "
                        ></div>
                    </vCol>
                    <vCol span="12">
                        <vFormItem
                            :label="
                                $t('boss.purchase.project', {
                                    defaultValue: '项目',
                                })
                            "
                            v-if="type == 'query'"
                        >
                            <div class="font-weight">
                                {{ getLineName(formData.lineId) }}
                            </div>
                        </vFormItem>
                        <vFormItem
                            :label="
                                $t('boss.purchase.project', {
                                    defaultValue: '项目',
                                })
                            "
                            :rules="required"
                            prop="lineId"
                            v-else
                        >
                            <!-- <vSelect
                                v-model="formData.lineId"
                                filterable
                                clearable
                                @on-change="getSupplierId(formData.lineId)"
                            > -->
                            <vSelect
                                v-model="formData.lineId"
                                filterable
                                clearable
                            >
                                <vOption
                                    v-for="(item, index) in getNewProductList"
                                    :value="item.value"
                                    :key="index"
                                    >{{ item.label }}</vOption
                                >
                            </vSelect>
                        </vFormItem>
                    </vCol>
                    <vCol span="12">
                        <vFormItem
                            :label="
                                $t('boss.purchase.supplier', {
                                    defaultValue: '供应商',
                                })
                            "
                            v-if="type == 'query'"
                        >
                            <div class="font-weight">
                                {{ getSupplier(formData.supplierId) }}
                            </div>
                        </vFormItem>
                        <vFormItem
                            :label="
                                $t('boss.purchase.supplier', {
                                    defaultValue: '供应商',
                                })
                            "
                            :rules="required"
                            prop="supplierId"
                            v-else
                        >
                            <!-- <vSelect
                                v-model="formData.supplierId"
                                filterable
                                clearable
                                @on-change="getPayment(formData.supplierId)"
                            > -->
                            <vSelect
                                v-model="formData.supplierId"
                                filterable
                                clearable
                            >
                                <vOption
                                    v-for="(item, index) in getNewSupplier"
                                    :value="item.value"
                                    :key="index"
                                    >{{ item.label }}</vOption
                                >
                            </vSelect>
                        </vFormItem>
                    </vCol>
                    <vCol span="12" v-if="type == 'query'">
                        <vFormItem
                            :label="
                                $t('boss.purchase.purchase_order_number', {
                                    defaultValue: '采购单号',
                                })
                            "
                        >
                            <div class="font-weight">
                                {{ formData.orderNo || "--" }}
                            </div>
                        </vFormItem>
                    </vCol>
                    <vCol span="12" v-if="type == 'query'">
                        <vFormItem
                            :label="
                                $t('boss.purchase.document_status', {
                                    defaultValue: '单据状态',
                                })
                            "
                        >
                            <div class="font-weight">
                                {{ getstatus(formData.orderStatus) }}
                            </div>
                        </vFormItem>
                    </vCol>
                    <vCol span="12">
                        <vFormItem
                            :label="
                                $t('boss.purchase.purchase_currency', {
                                    defaultValue: '采购币种',
                                })
                            "
                            v-if="type == 'query'"
                        >
                            <div class="font-weight">
                                {{ formData.currency }}
                            </div>
                        </vFormItem>
                        <vFormItem
                            :label="
                                $t('boss.purchase.purchase_currency', {
                                    defaultValue: '采购币种',
                                })
                            "
                            :rules="required"
                            prop="currency"
                            v-else
                        >
                            <vSelect
                                v-model="formData.currency"
                                :disabled="formData.paymentType == 'fk'"
                            >
                                <vOption
                                    v-for="(item, index) in getAllCurrency"
                                    :value="item.value"
                                    :key="index"
                                    >{{ item.label }}</vOption
                                >
                            </vSelect>
                        </vFormItem>
                    </vCol>

                    <vCol span="12" v-if="type != 'query'">
                        <vFormItem
                            :label="
                                $t(
                                    'boss.purchase.source_procurement_request_number',
                                    {
                                        defaultValue: '来源采购申请号',
                                    }
                                )
                            "
                        >
                            <vButton @click="showcheck"
                                >{{
                                    $t("boss.purchase.please_select", {
                                        defaultValue: "请选择",
                                    })
                                }}
                            </vButton>
                        </vFormItem>
                    </vCol>
                    <vCol span="12">
                        <vFormItem
                            :label="
                                $t('boss.purchase.procurement_model', {
                                    defaultValue: '采购模式',
                                })
                            "
                            v-if="type == 'query'"
                        >
                            <div class="font-weight">
                                {{
                                    getBuyMode(
                                        formData.paymentType,
                                        "paymentType"
                                    ).label || "--"
                                }}
                            </div>
                        </vFormItem>
                        <vFormItem
                            :label="
                                $t('boss.purchase.procurement_model', {
                                    defaultValue: '采购模式',
                                })
                            "
                            v-else
                            :rules="required"
                            prop="paymentType"
                        >
                            <vSelect
                                v-model="formData.paymentType"
                                filterable
                                clearable
                                @on-change="changePayment"
                            >
                                <vOption
                                    v-for="(item, index) in buyModeList"
                                    :value="item.value"
                                    :key="index"
                                    >{{ item.label }}</vOption
                                >
                            </vSelect>
                        </vFormItem>
                    </vCol>
                    <vCol span="12">
                        <vFormItem
                            :label="
                                $t('boss.purchase.purchaser', {
                                    defaultValue: '采购员',
                                })
                            "
                            v-if="type == 'query'"
                        >
                            <div class="font-weight">
                                {{
                                    getBuyMode(formData.poUserId, "poUserId")
                                        .label || "--"
                                }}
                            </div>
                        </vFormItem>

                        <vFormItem
                            :label="
                                $t('boss.purchase.purchaser', {
                                    defaultValue: '采购员',
                                })
                            "
                            v-else
                            :rules="required"
                            prop="paymentType"
                        >
                            <vSelect
                                v-model="formData.poUserId"
                                filterable
                                clearable
                            >
                                <vOption
                                    v-for="(item, index) in getUserList"
                                    :value="item.value"
                                    :key="index"
                                    >{{ item.label }}</vOption
                                >
                            </vSelect>
                        </vFormItem>
                    </vCol>
                    <vCol span="12">
                        <vFormItem
                            :label="
                                $t('boss.purchase.batch_number', {
                                    defaultValue: '批次号',
                                })
                            "
                        >
                            <div v-if="type == 'query'" class="font-weight">
                                {{ formData.refNo || "--" }}
                            </div>
                            <vInput v-else v-model="formData.refNo"></vInput>
                        </vFormItem>
                    </vCol>
                    <vCol span="12">
                        <vFormItem
                            :label="
                                $t('boss.purchase.source_no', {
                                    defaultValue: '来源单号',
                                })
                            "
                        >
                            <div v-if="type == 'query'" class="font-weight">
                                {{ formData.inboundRefNo || "--" }}
                            </div>
                            <vInput
                                v-else
                                v-model="formData.inboundRefNo"
                            ></vInput>
                        </vFormItem>
                    </vCol>

                    <vCol span="12">
                        <vFormItem
                            :label="
                                $t('boss.purchase.inspect_goods', {
                                    defaultValue: '是否需要验货',
                                })
                            "
                            v-if="type == 'query'"
                        >
                            <div class="font-weight">
                                {{
                                    formData.deny == 0
                                        ? $t("boss.purchase.deny", {
                                              defaultValue: "否",
                                          })
                                        : $t("boss.purchase.correct", {
                                              defaultValue: "是",
                                          })
                                }}
                            </div>
                        </vFormItem>
                        <vFormItem
                            :label="
                                $t('boss.purchase.inspect_goods', {
                                    defaultValue: '是否需要验货',
                                })
                            "
                            v-else
                            :rules="required"
                            prop="paymentType"
                        >
                            <vRadio
                                trueValue="0"
                                :strict="false"
                                v-model="formData.isNeedInspect"
                                class="margin-right-10"
                                >{{
                                    $t("boss.purchase.deny", {
                                        defaultValue: "否",
                                    })
                                }}</vRadio
                            >
                            <vRadio
                                trueValue="1"
                                :strict="false"
                                v-model="formData.isNeedInspect"
                                >{{
                                    $t("boss.purchase.correct", {
                                        defaultValue: "是",
                                    })
                                }}</vRadio
                            >
                        </vFormItem>
                    </vCol>

                    <vCol span="24" style="margin-top: -10px">
                        <div class="font-weight" style="margin-left: 30px">
                            {{
                                $t("boss.purchase.contract_terms_information", {
                                    defaultValue: "合同条款信息",
                                })
                            }}
                        </div>
                        <div
                            style="
                                width: 99%;
                                margin-left: 15px;
                                margin-bottom: 15px;
                                font-weight: bold;
                                border-bottom: 1px solid #eae7e7;
                            "
                        ></div>
                    </vCol>
                    <vCol span="12" v-if="type == 'query'">
                        <vFormItem
                            :label="
                                $t('boss.purchase.promise_delivery', {
                                    defaultValue: '承诺交货日期',
                                })
                            "
                        >
                            <div class="font-weight">
                                {{ formData.promiseDeliveryDate || "--" }}
                            </div>
                        </vFormItem>
                    </vCol>
                    <vCol span="12" v-else>
                        <vFormItem
                            :label="
                                $t('boss.purchase.promise_delivery', {
                                    defaultValue: '承诺交货日期',
                                })
                            "
                            :rules="required"
                            prop="promiseDeliveryDate"
                        >
                            <vDatepicker
                                v-model="formData.promiseDeliveryDate"
                                format="yyyy-mm-dd"
                            ></vDatepicker>
                        </vFormItem>
                    </vCol>
                    <vCol span="12" v-if="type == 'query'">
                        <vFormItem
                            :label="
                                $t('boss.purchase.buyer', {
                                    defaultValue: '买方',
                                })
                            "
                        >
                            <!-- <div class="font-weight">{{getBuyTypeLabel(formData.buyerType)}}</div> -->
                            <div class="font-weight">{{ this.buyerLabel }}</div>
                        </vFormItem>
                    </vCol>
                    <vCol span="12" v-else>
                        <vFormItem
                            :label="
                                $t('boss.purchase.buyer', {
                                    defaultValue: '买方',
                                })
                            "
                            :rules="
                                formData.paymentType === 'payment' ||
                                formData.paymentType === 'fk'
                                    ? required
                                    : ''
                            "
                            prop="buyerType"
                        >
                            <vSelect
                                v-model="formData.buyerType"
                                filterable
                                clearable
                            >
                                <vOption
                                    v-for="item in getBuyType"
                                    :value="item.value"
                                    :key="item.key"
                                    >{{ item.label }}</vOption
                                >
                            </vSelect>
                        </vFormItem>
                    </vCol>

                    <vCol span="12" v-if="type == 'query'">
                        <vFormItem
                            :label="
                                $t('boss.purchase.contract_signing', {
                                    defaultValue: '合同签订日期',
                                })
                            "
                        >
                            <div class="font-weight">
                                {{ formData.contractSignDate || "--" }}
                            </div>
                        </vFormItem>
                    </vCol>
                    <vCol span="12" v-else>
                        <vFormItem
                            :label="
                                $t('boss.purchase.contract_signing', {
                                    defaultValue: '合同签订日期',
                                })
                            "
                        >
                            <vDatepicker
                                v-model="formData.contractSignDate"
                                format="yyyy-mm-dd"
                            ></vDatepicker>
                        </vFormItem>
                    </vCol>
                    <vCol span="12">
                        <vFormItem
                            :label="
                                $t('boss.purchase.payer', {
                                    defaultValue: '付款方',
                                })
                            "
                            v-if="type == 'query'"
                        >
                            <div class="font-weight">
                                {{
                                    getBuyMode(
                                        formData.poPurchaserId,
                                        "poPurchaserId"
                                    ).purchaserName || "--"
                                }}
                            </div>
                        </vFormItem>
                        <vFormItem
                            :label="
                                $t('boss.purchase.payer', {
                                    defaultValue: '付款方',
                                })
                            "
                            v-else
                            prop="poPurchaserId"
                            :rules="
                                formData.paymentType === 'payment' ||
                                formData.paymentType === 'fk'
                                    ? required
                                    : []
                            "
                        >
                            <vSelect
                                v-model="formData.poPurchaserId"
                                filterable
                                clearable
                            >
                                <vOption
                                    v-for="(item, index) in purchaserList"
                                    :value="item.id"
                                    :key="index"
                                    >{{ item.purchaserName }}</vOption
                                >
                            </vSelect>
                        </vFormItem>
                    </vCol>

                    <!-- <vCol span="12">
                        <vFormItem label="付款账期(天)" v-if="type == 'query'">
                            <div class="font-weight">
                                {{
                                    formData.paymentDay &&
                                    formData.paymentDay != 0
                                        ? formData.paymentDay
                                        : "--"
                                }}
                            </div>
                        </vFormItem>
                        <vFormItem
                            label="付款账期(天)"
                            v-else
                            prop="paymentDay"
                            :rules="
                                formData.paymentType === 'payment' ||
                                formData.paymentType === 'fk'
                                    ? required
                                    : []
                            "
                        >
                            <vInputNumber
                                v-model="formData.paymentDay"
                            ></vInputNumber>
                        </vFormItem>
                    </vCol> -->
                    <!-- <vCol span="12">
                        <vFormItem label="预付款比例(%)" v-if="type == 'query'">
                            <div class="font-weight">
                                {{ formData.paymentRate || "--" }}
                            </div>
                        </vFormItem>
                        <vFormItem
                            label="预付款比例(%)"
                            v-else
                            prop="paymentRate"
                            :rules="
                                formData.paymentType === 'payment' ||
                                formData.paymentType === 'fk'
                                    ? required
                                    : []
                            "
                        >
                            <vInputNumber
                                v-model="formData.paymentRate"
                                min="0"
                                max="100"
                            ></vInputNumber>
                        </vFormItem>
                    </vCol> -->
                    <vCol span="12">
                        <vFormItem label="Payment Term" v-if="type == 'query'">
                            <div class="font-weight">
                                <span v-if="!paymentItem.paymentName">--</span>
                                <a
                                    v-else
                                    @click="
                                        handlePaymentDetail(
                                            formData.paymentTermId
                                        )
                                    "
                                    >{{ paymentItem.paymentName }}</a
                                >
                            </div>
                        </vFormItem>
                        <vFormItem
                            label="Payment Term"
                            v-else
                            prop="paymentName"
                            :rules="
                                formData.paymentType == 'fk' ||
                                formData.paymentType == 'payment'
                                    ? required
                                    : {}
                            "
                        >
                            <vInput v-model="paymentItem.paymentName" readonly>
                                <Icon
                                    style="
                                        cursor: pointer;
                                        font-size: 18px;
                                        margin-right: 5px;
                                    "
                                    slot="suffix"
                                    type="md-search"
                                    @click="this.handleChoosePayment"
                                ></Icon>
                            </vInput>
                        </vFormItem>
                    </vCol>

                    <vCol span="12">
                        <vFormItem
                            :label="
                                $t('boss.purchase.payment_instructions', {
                                    defaultValue: '付款说明',
                                })
                            "
                            v-if="type == 'query'"
                        >
                            <div class="font-weight">
                                {{ formData.paymentExplain || "--" }}
                            </div>
                        </vFormItem>
                        <vFormItem
                            :label="
                                $t('boss.purchase.payment_instructions', {
                                    defaultValue: '付款说明',
                                })
                            "
                            v-else
                        >
                            <vInput v-model="formData.paymentExplain"></vInput>
                        </vFormItem>
                    </vCol>
                    <vCol span="12">
                        <vFormItem
                            :label="
                                $t('boss.purchase.settlement_type', {
                                    defaultValue: '成本结算类型',
                                })
                            "
                            v-if="type == 'query'"
                        >
                            <div class="font-weight">
                                {{ formData.costType || "--" }}
                            </div>
                        </vFormItem>
                        <!-- <vFormItem
                            label="成本结算类型"
                            v-else
                            prop="costType"
                            :rules="
                                formData.paymentType === 'payment' ||
                                formData.paymentType === 'fk'
                                    ? required
                                    : []
                            "
                        > -->
                        <vFormItem
                            :label="
                                $t('boss.purchase.settlement_type', {
                                    defaultValue: '成本结算类型',
                                })
                            "
                            v-else
                            prop="costType"
                            :rules="required"
                        >
                            <vSelect
                                v-model="formData.costType"
                                filterable
                                clearable
                            >
                                <vOption value="FOB">FOB</vOption>
                                <vOption value="DDP">DDP</vOption>
                                <vOption value="DDU">DDU</vOption>
                                <vOption value="CIF">CIF</vOption>
                                <vOption value="EXW">EXW</vOption>
                                <vOption value="FCA">FCA</vOption>
                            </vSelect>
                        </vFormItem>
                    </vCol>

                    <vCol span="24" style="margin-top: -10px">
                        <div class="font-weight" style="margin-left: 30px">
                            {{
                                $t("boss.purchase.other_information", {
                                    defaultValue: "其他信息",
                                })
                            }}
                        </div>
                        <div
                            style="
                                width: 99%;
                                margin-left: 15px;
                                margin-bottom: 15px;
                                font-weight: bold;
                                border-bottom: 1px solid #eae7e7;
                            "
                        ></div>
                    </vCol>
                    <vCol span="12">
                        <vFormItem
                            :label="
                                $t('boss.purchase.warehouse', {
                                    defaultValue: '预计接收仓库',
                                })
                            "
                            prop="expectedReceiveWarehouseCode"
                            :rules="
                                type != 'query' &&
                                (formData.paymentType === 'payment' ||
                                    formData.paymentType === 'fk')
                                    ? required
                                    : []
                            "
                        >
                            <div v-if="type == 'query'" class="font-weight">
                                {{
                                    formData.expectedReceiveWarehouseCode ||
                                    "--"
                                }}
                            </div>
                            <vSelect
                                v-else
                                clearable
                                filterable
                                v-model="formData.expectedReceiveWarehouseId"
                                @on-change="
                                    getNewWarehouseCode(
                                        formData.expectedReceiveWarehouseId
                                    )
                                "
                                prop="expectedReceiveWarehouseId"
                            >
                                <vOption
                                    v-for="(
                                        item, index
                                    ) in getFilterDisabledWarehouse"
                                    :key="index"
                                    :value="item.value"
                                    >{{ item.label }}</vOption
                                >
                            </vSelect>
                        </vFormItem>
                    </vCol>

                    <!-- <vCol span="12">
                        <vFormItem label="预计上架日期" prop="ex">

                        </vFormItem>
                    </vCol> -->
                    <vCol span="12">
                        <vFormItem
                            :label="
                                $t('boss.purchase.delivery_port', {
                                    defaultValue: '预计交货港口',
                                })
                            "
                            prop="expectedDeliveryPort"
                            :rules="
                                type != 'query' &&
                                (formData.paymentType === 'payment' ||
                                    formData.paymentType === 'fk')
                                    ? required
                                    : []
                            "
                        >
                            <div v-if="type == 'query'" class="font-weight">
                                {{ formData.expectedDeliveryPort || "--" }}
                            </div>
                            <!-- <vInput v-else v-model="formData.expectedDeliveryPort"></vInput> -->
                            <Select
                                v-else
                                :filterable="true"
                                :clearable="true"
                                v-model="formData.expectedDeliveryPort"
                            >
                                <Option
                                    v-for="item in portList"
                                    :key="item.value"
                                    :value="item.value"
                                    >{{ item.label }}</Option
                                >
                            </Select>
                        </vFormItem>
                    </vCol>

                    <vCol span="12">
                        <vFormItem
                            :label="
                                $t(
                                    'boss.purchase.theoretical_latest_delivery_date',
                                    {
                                        defaultValue: '理论最晚交货日期',
                                    }
                                )
                            "
                            prop="theoryDeliveryDate"
                        >
                            <div class="font-weight">
                                {{ formData.theoryDeliveryDate || "--" }}
                            </div>
                            <span
                                v-if="
                                    !formData.theoryDeliveryDate &&
                                    type !== 'query' &&
                                    hasRequest
                                "
                                class="color-error"
                                >{{
                                    $t("boss.purchase.unable_to_calculate", {
                                        defaultValue:
                                            "无法计算，请检查基础数据",
                                    })
                                }}</span
                            >
                        </vFormItem>
                    </vCol>

                    <vCol span="12" v-if="type == 'query'">
                        <vFormItem
                            :label="
                                $t(
                                    'boss.purchase.latest_estimated_delivery_date',
                                    { defaultValue: '最新预计交货日期' }
                                )
                            "
                        >
                            <div class="font-weight">
                                {{ formData.expectedDeliveryDate || "--" }}
                            </div>
                        </vFormItem>
                    </vCol>
                    <!-- <vCol span="12" v-else>
                        <vFormItem label="预计交货日期" :rules="required" prop="expectedDeliveryDate">
                            <vDatepicker
                                v-model="formData.expectedDeliveryDate"
                                format="yyyy-mm-dd"
                            ></vDatepicker>
                        </vFormItem>
                    </vCol> -->

                    <!-- <vCol span="12" v-if="type == 'query'">
                        <vFormItem label="预计上架日期">
                            <div class="font-weight">
                                {{ formData.expectedNeedDate || "--" }}
                            </div>
                        </vFormItem>
                    </vCol>
                    <vCol span="12" v-else>
                        <vFormItem
                            label="预计上架日期"
                            prop="expectedNeedDate"
                            :rules="required"
                        >
                            <vDatepicker
                                v-model="formData.expectedNeedDate"
                                format="yyyy-mm-dd"
                            ></vDatepicker>
                        </vFormItem>
                    </vCol> -->

                    <vCol span="12" v-if="type == 'query'">
                        <vFormItem
                            :label="
                                $t('boss.purchase.expected_inspection_date', {
                                    defaultValue: '预计验货日期',
                                })
                            "
                        >
                            <div class="font-weight">
                                {{ formData.expectedInspectDate || "--" }}
                            </div>
                        </vFormItem>
                    </vCol>
                    <vCol span="12" v-else>
                        <vFormItem
                            :label="
                                $t('boss.purchase.expected_inspection_date', {
                                    defaultValue: '预计验货日期',
                                })
                            "
                        >
                            <vDatepicker
                                v-model="formData.expectedInspectDate"
                                format="yyyy-mm-dd"
                                :placeholder="
                                    $t('boss.purchase.default_delivery', {
                                        defaultValue:
                                            '若不填，则保存后默认和预计交货日期一致',
                                    })
                                "
                            ></vDatepicker>
                            <!-- <span class="color-error"
                                >若不填，则保存后默认和预计交货日期一致</span
                            > -->
                        </vFormItem>
                    </vCol>
                    <vCol span="12" v-if="type == 'query'">
                        <vFormItem
                            :label="
                                $t('boss.purchase.inspection_personnel', {
                                    defaultValue: '验货人员',
                                })
                            "
                        >
                            <div class="font-weight">
                                {{ formData.inspectPersonName || "--" }}
                            </div>
                        </vFormItem>
                    </vCol>
                    <vCol span="12" v-if="type == 'query'">
                        <vFormItem
                            :label="
                                $t('boss.purchase.inspection_status', {
                                    defaultValue: '验货状态',
                                })
                            "
                        >
                            <div class="font-weight">
                                {{
                                    formData.inspectStatus == 0
                                        ? $t(
                                              "boss.purchase.uninspected_goods",
                                              { defaultValue: "未验货" }
                                          )
                                        : formData.inspectStatus == 1
                                        ? $t(
                                              "boss.purchase.qualified_inspection",
                                              { defaultValue: "验货合格" }
                                          )
                                        : $t(
                                              "boss.purchase.unqualified_inspection",
                                              { defaultValue: "验货不合格" }
                                          )
                                }}
                            </div>
                        </vFormItem>
                    </vCol>
                    <vCol span="12" v-if="showaccount">
                        <vFormItem
                            :label="
                                $t('boss.purchase.ONITE_channel', {
                                    defaultValue: 'ONSITE渠道',
                                })
                            "
                            v-if="type == 'query'"
                        >
                            <div class="font-weight">
                                {{ formData.channelFlag || "--" }}
                            </div>
                        </vFormItem>
                        <vFormItem
                            :label="
                                $t('boss.purchase.ONITE_channel', {
                                    defaultValue: 'ONSITE渠道',
                                })
                            "
                            :rules="required"
                            prop="channelFlag"
                            v-else
                        >
                            <vSelect
                                clearable
                                filterable
                                v-model="formData.channelFlag"
                            >
                                <vOption
                                    v-for="(item, index) in channelList"
                                    :key="index"
                                    :value="item.accountFlag"
                                    >{{ item.accountFlag }}</vOption
                                >
                            </vSelect>
                        </vFormItem>
                    </vCol>
                    <vCol span="12" v-if="type == 'query'">
                        <vFormItem
                            :label="
                                $t('boss.purchase.associated_inventory_plan', {
                                    defaultValue: '关联入库计划单',
                                })
                            "
                        >
                            <div class="font-weight">
                                {{ stringNos || "--" }}
                            </div>
                        </vFormItem>
                    </vCol>
                    <vCol span="12" v-if="type == 'query'">
                        <vFormItem
                            :label="
                                $t('boss.purchase.expected_shelf_date', {
                                    defaultValue: '预计上架日期',
                                })
                            "
                        >
                            <div class="font-weight">
                                {{ formData.expectedFinishDate || "--" }}
                            </div>
                        </vFormItem>
                    </vCol>
                    <vCol span="12" v-else>
                        <vFormItem
                            :label="
                                $t('boss.purchase.expected_shelf_date', {
                                    defaultValue: '预计上架日期',
                                })
                            "
                            prop="expectedFinishDate"
                            :rules="required"
                        >
                            <vDatepicker
                                v-model="formData.expectedFinishDate"
                                format="yyyy-mm-dd"
                            ></vDatepicker>
                        </vFormItem>
                    </vCol>
                    <vCol span="12">
                        <vFormItem
                            :label="
                                $t('boss.purchase.notes', {
                                    defaultValue: '备注',
                                })
                            "
                        >
                            <div v-if="type == 'query'" class="font-weight">
                                {{ formData.remark || "--" }}
                            </div>
                            <vTextarea
                                v-else
                                v-model="formData.remark"
                            ></vTextarea>
                        </vFormItem>
                    </vCol>
                </vForm>
            </section>
            <template v-if="type != 'query'" slot="footer">
                <vButton
                    class="margin-right-20"
                    theme="primary"
                    @click="submit('submit')"
                    >{{
                        $t("boss.purchase.save_submit", {
                            defaultValue: "保存并提交",
                        })
                    }}</vButton
                >
                <vButton class="margin-right-20" theme="info" @click="submit">{{
                    $t("boss.purchase.save_draft", {
                        defaultValue: "保存为草稿",
                    })
                }}</vButton>
                <vButton class="margin-right-20" @click="cancel">{{
                    $t("boss.purchase.cancel", { defaultValue: "取消" })
                }}</vButton>
            </template>
        </compWrapper>
        <!-- 采购申明细 -->
        <compWrapper
            :title="
                $t('boss.purchase.purchase_details', {
                    defaultValue: '采购明细',
                })
            "
            theme="info"
        >
            <div
                v-if="formData.orderStatus === 'auditing_pass'"
                style="position: absolute; right: 15px; top: 2px"
            >
                <Button
                    class="margin-right-15"
                    type="primary"
                    @click="reduceNumber"
                    >{{
                        $t("boss.purchase.reduce_procurement", {
                            defaultValue: "减少采购数量",
                        })
                    }}</Button
                >
                <Button type="warning" @click="autoReduceNumber">{{
                    $t("boss.purchase.click_reduction", {
                        defaultValue: "一键减少采购数量",
                    })
                }}</Button>
            </div>
            <vForm
                :label-width="100"
                class="clearfix margin-15"
                v-if="type != 'query'"
                ref="detailform"
            >
                <vCol span="8">
                    <vFormItem label="ERPSKU">
                        <div style="height: 30px">
                            <Select
                                clearable
                                filterable
                                v-model="apperpsku"
                                ref="zierpselect"
                                remote
                                :remote-method="remoteMethod1"
                                :loading="loading1"
                                @on-change="getProductId(apperpsku)"
                            >
                                <Option
                                    v-for="json in erpSkusList"
                                    :value="json.name"
                                    :key="json.id"
                                    >{{ json.name }}</Option
                                >
                            </Select>
                        </div>
                    </vFormItem>
                </vCol>
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.purchase_quantity', {
                                defaultValue: '采购数量',
                            })
                        "
                    >
                        <vInputNumber
                            min="1"
                            v-model="appnumber"
                        ></vInputNumber>
                    </vFormItem>
                </vCol>
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.purchase_unit_price', {
                                defaultValue: '采购单价',
                            })
                        "
                    >
                        <vInput v-model="appacount"></vInput>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('boss.purchase.notes', {
                                defaultValue: '备注',
                            })
                        "
                    >
                        <vInput v-model="appremark"></vInput>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vButton
                        class="margin-left-10"
                        theme="primary"
                        @click="adddetail"
                        >{{ $t("boss.purchase.add", { defaultValue: "添加" }) }}
                    </vButton>
                    <vButton
                        class="margin-left-10"
                        theme="success"
                        @click="importExcel"
                        >{{
                            $t("boss.purchase.info", { defaultValue: "导入" })
                        }}</vButton
                    >
                </vCol>
            </vForm>
            <vCol span="24" class="margin-top-15">
                <div class="margin-left-15 margin-bottom-15">
                    <span
                        >{{
                            $t("boss.purchase.total_SKU_types", {
                                defaultValue: "SKU种数合计",
                            })
                        }}：{{ allnumber }}</span
                    >
                    <span style="margin-left: 15px"
                        >{{
                            $t("boss.purchase.total_number", {
                                defaultValue: "总数量",
                            })
                        }}：{{ allacount }}
                    </span>
                    <span style="margin-left: 15px"
                        >{{
                            $t("boss.purchase.total_amount", {
                                defaultValue: "总金额",
                            })
                        }}：{{ allamount }}</span
                    >
                    <span
                        style="margin-left: 15px"
                        v-if="type == 'query' && formData.paymentType == 'fk'"
                        >{{
                            $t("boss.purchase.export_amount_dollars", {
                                defaultValue: "外销美金总金额",
                            })
                        }}：{{ usdAmount }}</span
                    >
                    <vButton
                        class="pull-right margin-right-15"
                        theme="success"
                        @click="uploaddetail"
                        >{{
                            $t("boss.purchase.download_details", {
                                defaultValue: "下载明细",
                            })
                        }}</vButton
                    >
                </div>
            </vCol>
            <vCol span="24">
                <vButton
                    class="margin-left-15"
                    v-if="type != 'query'"
                    @click="alertbox"
                    >{{
                        $t("boss.purchase.clear_all", {
                            defaultValue: "全部清除",
                        })
                    }}</vButton
                >
                <vTable
                    class="margin-15"
                    :columns="detailcolumns"
                    :data="datalist2"
                    size="small"
                    ref="tabledetail"
                    border
                ></vTable>
            </vCol>
        </compWrapper>
        <!-- 金融风控信息 -->
        <compWrapper
            v-if="formData.paymentType === 'fk'"
            :title="
                $t('boss.purchase.risk_control', {
                    defaultValue: '金融风控信息',
                })
            "
            theme="warning"
        >
            <vForm
                :label-width="120"
                class="clearfix margin-15"
                :model="poOrderFk"
                ref="fkform"
            >
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.funding_party', {
                                defaultValue: '资金方',
                            })
                        "
                        prop="funderName"
                        :rules="type !== 'query' ? required : []"
                    >
                        <div class="font-weight" v-if="type === 'query'">
                            {{ getFunderName(poOrderFk.funderId) }}
                        </div>
                        <vSelect
                            v-else
                            v-model="poOrderFk.funderId"
                            @on-change="getRate(poOrderFk.funderId)"
                        >
                            <vOption
                                v-for="(item, index) in funderList"
                                :key="index"
                                :value="item.id"
                                >{{ item.funderName }}</vOption
                            >
                        </vSelect>
                    </vFormItem>
                </vCol>
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.exchange_rate', {
                                defaultValue: '汇率',
                            })
                        "
                        prop="exchangeRate"
                        :rules="type !== 'query' ? required : []"
                    >
                        <div class="font-weight" v-if="type === 'query'">
                            {{ poOrderFk.exchangeRate }}
                        </div>
                        <vInput
                            v-else
                            v-model="poOrderFk.exchangeRate"
                        ></vInput>
                    </vFormItem>
                </vCol>
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.contract_number', {
                                defaultValue: '合同编号',
                            })
                        "
                        prop="referenceNo"
                        :rules="type !== 'query' ? required : []"
                    >
                        <div class="font-weight" v-if="type === 'query'">
                            {{ poOrderFk.referenceNo }}
                        </div>
                        <vInput v-else v-model="poOrderFk.referenceNo"></vInput>
                    </vFormItem>
                </vCol>
                <!-- <vCol span="8">
                    <vFormItem
                        label="收货人名称"
                        prop="paymentReceiveName"
                    >
                        <div class="font-weight" v-if="type === 'query'">
                            {{ poOrderFk.referenceNo }}
                        </div>
                        <vInput v-else v-model="poOrderFk.paymentReceiveName"></vInput>
                    </vFormItem>
                </vCol>
                <vCol span="8">
                    <vFormItem
                        label="收货人银行"
                        prop="paymentReceiveBank"
                    >
                        <div class="font-weight" v-if="type === 'query'">
                            {{ poOrderFk.paymentReceiveBank }}
                        </div>
                        <vInput v-else v-model="poOrderFk.paymentReceiveBank"></vInput>
                    </vFormItem>
                </vCol>
                <vCol span="8">
                    <vFormItem
                        label="收款人银行账号"
                        prop="paymentReceiveAccountNo"
                    >
                        <div class="font-weight" v-if="type === 'query'">
                            {{ poOrderFk.paymentReceiveAccountNo }}
                        </div>
                        <vInput v-else v-model="poOrderFk.paymentReceiveAccountNo"></vInput>
                    </vFormItem>
                </vCol> -->

                <!-- <vCol span="8">
                    <vFormItem
                        label="收款人银行地址"
                        prop="paymentReceiveBankAddress"
                    >
                        <div class="font-weight" v-if="type === 'query'">
                            {{ poOrderFk.paymentReceiveBankAddress }}
                        </div>
                        <vInput v-else v-model="poOrderFk.paymentReceiveBankAddress"></vInput>
                    </vFormItem>
                </vCol> -->

                <!-- <vCol span="8">
                    <vFormItem
                        label="人民币收款银行名称"
                        prop="cnyPaymentReceiveBank"
                    >
                        <div class="font-weight" v-if="type === 'query'">
                            {{ poOrderFk.cnyPaymentReceiveBank }}
                        </div>
                        <vInput v-else v-model="poOrderFk.cnyPaymentReceiveBank"></vInput>
                    </vFormItem>
                </vCol>

                <vCol span="8">
                    <vFormItem
                        label="人民币收款银行账号"
                        prop="cnyPaymentReceiveAccountNo"
                    >
                        <div class="font-weight" v-if="type === 'query'">
                            {{ poOrderFk.cnyPaymentReceiveAccountNo }}
                        </div>
                        <vInput v-else v-model="poOrderFk.cnyPaymentReceiveAccountNo"></vInput>
                    </vFormItem>
                </vCol>

                <vCol span="8">
                    <vFormItem
                        label="美金银行名称"
                        prop="usdPaymentReceiveBank"
                    >
                        <div class="font-weight" v-if="type === 'query'">
                            {{ poOrderFk.usdPaymentReceiveBank }}
                        </div>
                        <vInput v-else v-model="poOrderFk.usdPaymentReceiveBank"></vInput>
                    </vFormItem>
                </vCol>

                <vCol span="8">
                    <vFormItem
                        label="美金银行账号"
                        prop="usdPaymentReceiveAccountNo"
                    >
                        <div class="font-weight" v-if="type === 'query'">
                            {{ poOrderFk.usdPaymentReceiveAccountNo }}
                        </div>
                        <vInput v-else v-model="poOrderFk.usdPaymentReceiveAccountNo"></vInput>
                    </vFormItem>
                </vCol>
                
                <vCol span="8">
                    <vFormItem
                        label="美金银行地址"
                        prop="usdPaymentReceiveBankAddress"
                    >
                        <div class="font-weight" v-if="type === 'query'">
                            {{ poOrderFk.usdPaymentReceiveBankAddress }}
                        </div>
                        <vInput v-else v-model="poOrderFk.usdPaymentReceiveBankAddress"></vInput>
                    </vFormItem>
                </vCol>
                
                <vCol span="8">
                    <vFormItem
                        label="Swift Code"
                        prop="usdPaymentReceiveSwiftCode"
                    >
                        <div class="font-weight" v-if="type === 'query'">
                            {{ poOrderFk.usdPaymentReceiveSwiftCode }}
                        </div>
                        <vInput v-else v-model="poOrderFk.usdPaymentReceiveSwiftCode"></vInput>
                    </vFormItem>
                </vCol>

                <vCol span="8">
                    <vFormItem
                        label="人民币银行地址"
                        prop="cnyPaymentReceiveBankAddress"
                    >
                        <div class="font-weight" v-if="type === 'query'">
                            {{ poOrderFk.cnyPaymentReceiveBankAddress }}
                        </div>
                        <vInput v-else v-model="poOrderFk.cnyPaymentReceiveBankAddress"></vInput>
                    </vFormItem>
                </vCol> -->

                <vCol span="24" style="margin-top: -10px">
                    <div class="font-weight" style="margin-left: 30px">
                        {{
                            $t("boss.purchase.purchase_contract_information", {
                                defaultValue: "采购合同信息",
                            })
                        }}
                    </div>
                    <div
                        style="
                            width: 99%;
                            margin-left: 15px;
                            margin-bottom: 15px;
                            font-weight: bold;
                            border-bottom: 1px solid #eae7e7;
                        "
                    ></div>
                </vCol>

                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.delivery_time', {
                                defaultValue: '提货时间',
                            })
                        "
                        prop="pickUpTime"
                        :rules="type !== 'query' ? required : []"
                    >
                        <div class="font-weight" v-if="type === 'query'">
                            {{ poOrderFk.pickUpTime || "--" }}
                        </div>
                        <vDatepicker
                            v-else
                            type="date"
                            v-model="poOrderFk.pickUpTime"
                        ></vDatepicker>
                    </vFormItem>
                </vCol>
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.shortage_ratio', {
                                defaultValue: '溢短装比例(%)',
                            })
                        "
                        prop="exceedRatio"
                        :rules="type !== 'query' ? required : []"
                    >
                        <div class="font-weight" v-if="type === 'query'">
                            {{ poOrderFk.exceedRatio }}
                        </div>
                        <vInput v-else v-model="poOrderFk.exceedRatio"></vInput>
                    </vFormItem>
                </vCol>
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.risk_premium_ratio', {
                                defaultValue: '风险金比例',
                            })
                        "
                        prop="advanceRate"
                        :rules="numberValid"
                    >
                        <div class="font-weight" v-if="type === 'query'">
                            {{ poOrderFk.advanceRate }}
                        </div>
                        <div class="clearfix" v-else>
                            <vCol span="20">
                                <vInputNumber
                                    :min="0"
                                    v-model="poOrderFk.advanceRate"
                                ></vInputNumber>
                            </vCol>
                            <vCol span="4" style="text-align: right">%</vCol>
                        </div>
                    </vFormItem>
                </vCol>
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.risk_fund', {
                                defaultValue: '风险金',
                            })
                        "
                        prop="advance"
                        :rules="numberValid"
                    >
                        <div class="font-weight" v-if="type === 'query'">
                            {{ poOrderFk.advance }}
                        </div>
                        <vInput v-else v-model="poOrderFk.advance"></vInput>
                    </vFormItem>
                </vCol>
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.risk_fund_requirement', {
                                defaultValue: '风险金要求',
                            })
                        "
                    >
                        <div class="font-weight" v-if="type === 'query'">
                            {{ poOrderFk.advanceRequirement || "--" }}
                        </div>
                        <vInput
                            v-else
                            v-model="poOrderFk.advanceRequirement"
                        ></vInput>
                    </vFormItem>
                </vCol>
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.procurement_contract', {
                                defaultValue: '采购合同结算方式',
                            })
                        "
                    >
                        <div class="font-weight" v-if="type === 'query'">
                            {{
                                poOrderFk.purchaseSettlementMethod === 1
                                    ? $t("boss.purchase.money_transfer", {
                                          defaultValue: "汇款",
                                      })
                                    : $t("boss.purchase.transfer_accounts", {
                                          defaultValue: "转账",
                                      })
                            }}
                        </div>
                        <vSelect
                            v-else
                            clearable
                            v-model="poOrderFk.purchaseSettlementMethod"
                        >
                            <vOption :value="1">{{
                                $t("boss.purchase.money_transfer", {
                                    defaultValue: "汇款",
                                })
                            }}</vOption>
                            <vOption :value="2">{{
                                $t("boss.purchase.transfer_accounts", {
                                    defaultValue: "转账",
                                })
                            }}</vOption>
                        </vSelect>
                    </vFormItem>
                </vCol>
                <!-- <vCol span="8">
                    <vFormItem label="结算天数" >
                        <div
                            class="font-weight"
                            v-if="type === 'query'"
                        >{{poOrderFk.purchaseSettlementDays}}</div>
                        <vInput v-else v-model="poOrderFk.purchaseSettlementDays"></vInput>
                    </vFormItem>
                </vCol> -->
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.delivery_address', {
                                defaultValue: '提货地址',
                            })
                        "
                    >
                        <div class="font-weight" v-if="type === 'query'">
                            {{ poOrderFk.pickUpAddress || "--" }}
                        </div>
                        <vInput
                            v-else
                            v-model="poOrderFk.pickUpAddress"
                        ></vInput>
                    </vFormItem>
                </vCol>
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.delivery_method', {
                                defaultValue: '提货方式',
                            })
                        "
                    >
                        <div class="font-weight" v-if="type === 'query'">
                            {{ poOrderFk.pickUpMethod || "--" }}
                        </div>
                        <vInput
                            v-else
                            v-model="poOrderFk.pickUpMethod"
                        ></vInput>
                    </vFormItem>
                </vCol>

                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.consignee', {
                                defaultValue: '提货人',
                            })
                        "
                    >
                        <div class="font-weight" v-if="type === 'query'">
                            {{ poOrderFk.consignee || "--" }}
                        </div>
                        <vInput v-else v-model="poOrderFk.consignee"></vInput>
                    </vFormItem>
                </vCol>
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.consignee_phone', {
                                defaultValue: '提货人联系电话',
                            })
                        "
                    >
                        <div class="font-weight" v-if="type === 'query'">
                            {{ poOrderFk.phone || "--" }}
                        </div>
                        <vInput v-else v-model="poOrderFk.phone"></vInput>
                    </vFormItem>
                </vCol>
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.delivery_requirements', {
                                defaultValue: '提货要求',
                            })
                        "
                    >
                        <div class="font-weight" v-if="type === 'query'">
                            {{ poOrderFk.pickUpRequirement || "--" }}
                        </div>
                        <vInput
                            v-else
                            v-model="poOrderFk.pickUpRequirement"
                        ></vInput>
                    </vFormItem>
                </vCol>

                <vCol span="24" style="margin-top: -10px">
                    <div class="font-weight" style="margin-left: 30px">
                        {{
                            $t("boss.purchase.export_contract_Information", {
                                defaultValue: "外销合同信息",
                            })
                        }}
                    </div>
                    <div
                        style="
                            width: 99%;
                            margin-left: 15px;
                            margin-bottom: 15px;
                            font-weight: bold;
                            border-bottom: 1px solid #eae7e7;
                        "
                    ></div>
                </vCol>

                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.latest_delivery_date', {
                                defaultValue: '最迟交货日期',
                            })
                        "
                        prop="latestDeliveryTime"
                        :rules="type !== 'query' ? required : ''"
                    >
                        <div class="font-weight" v-if="type === 'query'">
                            {{ poOrderFk.latestDeliveryTime || "--" }}
                        </div>
                        <vDatepicker
                            v-else
                            type="date"
                            v-model="poOrderFk.latestDeliveryTime"
                        ></vDatepicker>
                    </vFormItem>
                </vCol>
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.settlement_method', {
                                defaultValue: '外销合同结算方式',
                            })
                        "
                    >
                        <div class="font-weight" v-if="type === 'query'">
                            {{
                                poOrderFk.exportSettlementMethod === 1
                                    ? $t("boss.purchase.money_transfer", {
                                          defaultValue: "汇款",
                                      })
                                    : $t("boss.purchase.transfer_accounts", {
                                          defaultValue: "转账",
                                      })
                            }}
                        </div>
                        <vSelect
                            v-else
                            clearable
                            v-model="poOrderFk.exportSettlementMethod"
                        >
                            <vOption :value="1">{{
                                $t("boss.purchase.money_transfer", {
                                    defaultValue: "汇款",
                                })
                            }}</vOption>
                            <vOption :value="2">{{
                                $t("boss.purchase.transfer_accounts", {
                                    defaultValue: "转账",
                                })
                            }}</vOption>
                        </vSelect>
                    </vFormItem>
                </vCol>
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.settlement_export_contracts', {
                                defaultValue: '外销合同结算天数',
                            })
                        "
                        prop="exportSettlementDays"
                        :rules="numberValid"
                    >
                        <div class="font-weight" v-if="type === 'query'">
                            {{ poOrderFk.exportSettlementDays }}
                        </div>
                        <!-- <vInput v-else v-model="poOrderFk.exportSettlementDays"></vInput> -->
                        <vSelect
                            v-else
                            clearable
                            v-model="poOrderFk.exportSettlementDays"
                            @on-attach="getProtocolItemId"
                        >
                            <vOption
                                v-for="item in exportContractDayList"
                                :value="item.billPeriod"
                                :attach="item.protocolItemId"
                                :key="item.protocolItemId"
                                >{{ item.financin }}</vOption
                            >
                        </vSelect>
                    </vFormItem>
                </vCol>
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.currency_settlement', {
                                defaultValue: '外销合同结算币种',
                            })
                        "
                    >
                        <div class="font-weight" v-if="type === 'query'">
                            {{ poOrderFk.exportSettlementCurrency || "--" }}
                        </div>
                        <vSelect
                            v-else
                            clearable
                            v-model="poOrderFk.exportSettlementCurrency"
                        >
                            <vOption value="USD">USD</vOption>
                        </vSelect>
                    </vFormItem>
                </vCol>
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.trade_term', {
                                defaultValue: '贸易术语',
                            })
                        "
                        prop="tradeTerm"
                        :rules="type !== 'query' ? required : ''"
                    >
                        <div class="font-weight" v-if="type === 'query'">
                            {{ poOrderFk.tradeTerm || "--" }}
                        </div>
                        <vInput v-else v-model="poOrderFk.tradeTerm"></vInput>
                    </vFormItem>
                </vCol>
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.delivery_location', {
                                defaultValue: '交货地点',
                            })
                        "
                    >
                        <div class="font-weight" v-if="type === 'query'">
                            {{ poOrderFk.deliveryAddress || "--" }}
                        </div>
                        <vInput
                            v-else
                            v-model="poOrderFk.deliveryAddress"
                            :placeholder="
                                $t('boss.purchase.freight_forwarder', {
                                    defaultValue: '货代提货点',
                                })
                            "
                        ></vInput>
                    </vFormItem>
                </vCol>

                <vCol span="24" style="margin-top: -10px">
                    <div class="font-weight" style="margin-left: 30px">
                        {{
                            $t("boss.purchase.other_information", {
                                defaultValue: "其它信息",
                            })
                        }}
                    </div>
                    <div
                        style="
                            width: 99%;
                            margin-left: 15px;
                            margin-bottom: 15px;
                            font-weight: bold;
                            border-bottom: 1px solid #eae7e7;
                        "
                    ></div>
                </vCol>

                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.domestic_transportation', {
                                defaultValue: '国内运输',
                            })
                        "
                    >
                        <div class="font-weight" v-if="type === 'query'">
                            {{
                                poOrderFk.domesticTransport === 1
                                    ? $t(
                                          "boss.purchase.domestic_transportation",
                                          {
                                              defaultValue: "国内运输",
                                          }
                                      )
                                    : "--"
                            }}
                        </div>
                        <vSelect
                            clearable
                            v-else
                            v-model="poOrderFk.domesticTransport"
                        >
                            <vOption :value="1">{{
                                $t("boss.purchase.domestic_transportation", {
                                    defaultValue: "国内运输",
                                })
                            }}</vOption>
                        </vSelect>
                    </vFormItem>
                </vCol>
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.initial_transportation', {
                                defaultValue: '头程运输',
                            })
                        "
                    >
                        <div class="font-weight" v-if="type === 'query'">
                            {{
                                getTransport(poOrderFk.firstWayTransport) ||
                                "--"
                            }}
                        </div>
                        <vSelect
                            clearable
                            v-else
                            v-model="poOrderFk.firstWayTransport"
                        >
                            <vOption
                                v-for="item in transoprtList"
                                :key="item.key"
                                :value="item.value"
                                >{{ item.label }}</vOption
                            >
                        </vSelect>
                    </vFormItem>
                </vCol>
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.storage_services', {
                                defaultValue: '仓储服务',
                            })
                        "
                    >
                        <div class="font-weight" v-if="type === 'query'">
                            {{
                                poOrderFk.warehouseService === 0
                                    ? $t("boss.purchase.not_enabled", {
                                          defaultValue: "不启用",
                                      })
                                    : $t("boss.purchase.enabled", {
                                          defaultValue: "启用",
                                      })
                            }}
                        </div>
                        <vSelect
                            clearable
                            v-else
                            v-model="poOrderFk.warehouseService"
                        >
                            <vOption :value="0">{{
                                $t("boss.purchase.not_enabled", {
                                    defaultValue: "不启用",
                                })
                            }}</vOption>
                            <vOption :value="1">{{
                                $t("boss.purchase.enabled", {
                                    defaultValue: "启用",
                                })
                            }}</vOption>
                        </vSelect>
                    </vFormItem>
                </vCol>
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.delivery_service', {
                                defaultValue: '配送服务',
                            })
                        "
                    >
                        <div class="font-weight" v-if="type === 'query'">
                            {{
                                poOrderFk.warehouseService === 0
                                    ? $t("boss.purchase.not_enabled", {
                                          defaultValue: "不启用",
                                      })
                                    : $t("boss.purchase.enabled", {
                                          defaultValue: "启用",
                                      })
                            }}
                        </div>
                        <vSelect
                            clearable
                            v-else
                            v-model="poOrderFk.deliveryService"
                        >
                            <vOption :value="0">{{
                                $t("boss.purchase.not_enabled", {
                                    defaultValue: "不启用",
                                })
                            }}</vOption>
                            <vOption :value="1">{{
                                $t("boss.purchase.enabled", {
                                    defaultValue: "启用",
                                })
                            }}</vOption>
                        </vSelect>
                    </vFormItem>
                </vCol>

                <vCol span="24">
                    <vFormItem
                        v-if="type !== 'query'"
                        :label="
                            $t('boss.purchase.purchase_contract', {
                                defaultValue: '采购合同',
                            })
                        "
                        prop="purchaseContractMeta"
                        :rules="required"
                    >
                        <!-- <vInput v-model="poOrderFk.purchaseContractMeta"></vInput> -->
                        <Button
                            type="success"
                            v-if="purchaseList.length == 0"
                            @click="purchaseUpload"
                            >{{
                                $t("boss.purchase.upload", {
                                    defaultValue: "上传",
                                })
                            }}</Button
                        >
                    </vFormItem>
                    <Table
                        class="margin-25"
                        :columns="purchaseColumns"
                        :data="purchaseList"
                        size="small"
                        ref="table1"
                        border
                    ></Table>
                </vCol>
                <vCol span="24">
                    <vFormItem
                        v-if="type !== 'query'"
                        :label="
                            $t('boss.purchase.export_contract', {
                                defaultValue: '外销合同',
                            })
                        "
                        prop="exportContractMeta"
                        :rules="required"
                    >
                        <!-- <vInput v-model="poOrderFk.exportContractMeta"></vInput> -->
                        <Button
                            type="success"
                            v-if="exportList.length == 0"
                            @click="exportUpload"
                            >{{
                                $t("boss.purchase.upload", {
                                    defaultValue: "上传",
                                })
                            }}</Button
                        >
                    </vFormItem>
                    <Table
                        class="margin-25"
                        :columns="exportColumns"
                        :data="exportList"
                        size="small"
                        ref="table2"
                        border
                    ></Table>
                </vCol>
            </vForm>
        </compWrapper>

        <!-- 上传附件 -->
        <compWrapper
            :title="
                $t('boss.purchase.attachment_information', {
                    defaultValue: '附件信息',
                })
            "
            theme="success"
        >
            <vButton
                v-if="type != 'query'"
                class="margin-top-15 margin-left-15"
                theme="primary"
                @click="adddocument"
                >{{
                    $t("boss.purchase.add_attachment", {
                        defaultValue: "添加附件",
                    })
                }}</vButton
            >
            <span v-if="type != 'query'" class="margin-left-10 color-error">{{
                $t("boss.purchase.attachments_uploaded", {
                    defaultValue: "最多传5个附件，超过请压缩后再上传",
                })
            }}</span>
            <vTable
                class="margin-15"
                :columns="doccolumns"
                :data="docList"
                size="small"
                ref="tabledetail"
                border
            ></vTable>
        </compWrapper>
        <!-- 关联钉钉审批 -->
        <compWrapper
            :title="
                $t('boss.purchase.related_DingTalk_approval', {
                    defaultValue: '关联钉钉审批',
                })
            "
            theme="warning"
            v-if="type == 'query'"
        >
            <vTable
                class="margin-15"
                :columns="dingdingcolumns"
                :data="dingdingData"
                size="small"
                ref="tableaontact"
                border
            ></vTable>
        </compWrapper>
        <!-- 操作历史 -->
        <compWrapper
            :title="
                $t('boss.purchase.operations_history', {
                    defaultValue: '操作历史',
                })
            "
            theme="gray"
            v-if="type == 'query'"
        >
            <compLog :data="logList"></compLog>
        </compWrapper>

        <!-- 两种弹框全局弹框 1:简便弹框包含alert和formdata -->
        <compModal
            v-model="modalProps.show"
            v-bind="modalProps"
            @on-confirm="modalProps.show = false"
            @on-close="closemodalprops"
        >
            <component
                :is="modalProps.component"
                v-bind="modalProps"
                @on-close="closemodalprops"
                v-on="modalProps.on"
            />
        </compModal>

        <!-- 2：自定义弹框内容，包含component -->
        <vModal
            v-model="handle.show"
            :title="handle.title"
            :width="handle.width || 460"
            :showFooter="false"
        >
            <component
                :is="handle.component"
                v-bind="handle"
                @on-close="handle.show = false"
                v-on="handle.on"
            ></component>
            <!-- <footer slot="footer" v-show="false"></footer> -->
        </vModal>

        <vModal
            v-model="upload.show"
            :title="upload.title"
            v-bind="upload"
            :showFooter="false"
        >
            <compMutiUpload
                v-bind="mutiFileProps"
                @on-success="uploadSuccess"
                @on-cancel="cancelMutiUpload"
            ></compMutiUpload>
        </vModal>

        <vModal
            class="hidefooter"
            v-model="operate.show"
            :title="operate.title"
            v-bind="operate"
        >
            <compUpload
                v-bind="getFileProps"
                @on-success="aaasuccess"
                @on-cancel="cancelUpload"
            />
            <footer slot="footer" v-show="false"></footer>
        </vModal>
        <vLoading size="large" transfer :loading="loading"></vLoading>
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import {
    HttpGetOrderOne,
    HttpSaveOrderOne,
    HttpDeleteOrderFile,
    HttpFindByOrgIdAndOrgWarehouseId,
    HttpGetProductPrice,
    HttpGetOrderNotes,
    HttpDelAttach,
    HttpDelAttachNew,
    HttpDelAttachPurchase,
    HttpDelAttachExport,
    HttpFindProvidersByOrg,
    HttpGetPurchaserList,
    HttpGetAuditing,
    HttpGetOrderSubmit,
    HttpGetOrderClose,
    HttpGetContractSignDate,
    HttpGetExpectedInspectDate,
    HttpGetExpectedFinishDate,
    HttpGetSystemPortList,
    HttpUpdateExpectDeliveryDate,
    HttpGetLastDeliveryDate,
    HttpGetExpectedDate,
    HttpBatchLastDate,
    HttpUpdateDoc,
    HttpGetPaymentByOrgId,
    HttpGetPaymentDetail,
    HttpBackSubmit,
    HttpGetDingLog,
    HttpFilterDisabledWarehouse,
} from "@/service/purchase/purchase";

import delivery from "./delivery";
import comInspection from "./inspection";
import reduceNumberComponent from "./reduceNumber";

import { HttpGetErpsku } from "@/service/aftersales/aftersales";
import { HttpSysOpLog } from "@/service/boss/allot";

import compCheck from "./compcheck";
import compexpecteddate from "./compexpecteddate";
import mixin from "../../mixin";
import compPaymentTermList from "../../paymenttermlist.vue";
import compPaymentTermDetail from "../../paymenttermdetail.vue";
import compLock from "../lock.vue";
export default {
    props: ["activeid", "querytype", "comorderno"],
    mixins: [mixin],
    components: {
        compWrapper: () => import("@components/templates/wrapper"),
        compFormQuery: () => import("@components/templates/formquery"),
        compFormEdit: () => import("@components/templates/formedit"),
        compLog: () => import("@components/templates/log"),
        compUpload: () => import("@components/templates/upload"),
        compModal: () => import("@components/templates/modal"),
        compCheck,
        delivery,
        comInspection,
        reduceNumberComponent,
        compexpecteddate,
        compPaymentTermList,
        compPaymentTermDetail,
        compLock,
    },
    data() {
        return {
            type: this.$route.params.type,
            id: this.$route.query.id,
            formData: {
                lineId: "",
                currency: "USD",
                paymentType: "undefined",
                paymentRate: "",
                poUserId: this.$store.state.userinfo.id,
            },
            poOrderFk: {
                exceedRatio: "5",
                exportSettlementCurrency: "USD",
            },
            buyModeList: [
                {
                    value: "payment",
                    label: this.$t("boss.purchase.self_procurement", {
                        defaultValue: "自采",
                    }),
                },
                {
                    value: "unpayment",
                    label: this.$t("boss.purchase.agency_operations", {
                        defaultValue: "代运营",
                    }),
                },
                {
                    value: "fk",
                    label: this.$t(
                        "boss.purchase.financial_procurement_agency",
                        {
                            defaultValue: "金融代采",
                        }
                    ),
                },
                {
                    value: "undefined",
                    label: this.$t("boss.purchase.other", {
                        defaultValue: "其他",
                    }),
                },
            ],
            updatestatus: [],
            showaccount: false,
            // modal1:false,
            logList: [],
            docList: [],
            loading: false,
            loading1: false,
            erpSkusList: [],
            datalist1: [],
            datalist2: [],
            allnumber: 0,
            allacount: 0,
            allamount: 0,
            usdAmount: 0,
            apperpsku: "",
            appnumber: 1,
            appacount: 0,
            appremark: "",
            required: [
                {
                    required: true,
                    message: this.$t("boss.purchase.fill_in", {
                        defaultValue: "该信息不能为空,请填写",
                    }),
                },
            ],
            operate: {
                id: null,
                title: "",
                show: false,
                actionurl: "",
                name: "",
                boxtype: "",
                downexcel: "",
                component: null,
            },
            handle: {
                show: false,
                title: "",
                component: null,
            },
            modalProps: {
                show: false,
            },
            bossUrl: process.env.VUE_APP_APIURL_BOSS,
            proidarr: [],
            applicateOrders: "",
            poOrderItem: [],
            stringNos: "",
            channelList: [],
            funderList: [],
            purchaseList: [],
            exportList: [],
            rateDisabled: false,
            upload: {
                show: false,
            },
            paymentItem: {
                paymentTermId: "",
                paymentName: "",
            },
            paymentList: [],
            purchaserList: [],
            portList: [],
            purchaserList: [],
            exportContractDayList: [],
            numberValid: [
                {
                    required: true,
                    message: this.$t("boss.purchase.fill_in", {
                        defaultValue: "该信息不能为空,请填写",
                    }),
                },
                {
                    trigger: "blur",
                    validator: (rule, value = "", callback) => {
                        if (/^\d+(\.\d+)?$/.test(value)) {
                            callback();
                        } else {
                            callback(
                                new Error(
                                    this.$t(
                                        "boss.purchase.without_thousandths",
                                        {
                                            defaultValue:
                                                "请输入正确的不含千分位的数字格式",
                                        }
                                    )
                                )
                            );
                        }
                    },
                },
            ],
            hasRequest: false,
            isHasDate: false,
            isLock: true,
            dingdingData: [],
            ajaxFBBFilterDisabledAllWarehouse: [],
        };
    },
    async created() {
        await this.getAjaxFBBFilterDisabledAllWarehouse();
        if (this.type == "add") this.isLock = false;
        this.getPortList();

        this.update();
    },
    watch: {
        comorderno() {
            this.update();
        },
        "formData.expectedDeliveryPort": {
            immediate: true,
            handler(val) {
                if (!val)
                    return this.$set(this.formData, "theoryDeliveryDate", null);
                // 查看页不调用
                if (this.type == "query") return;
                this.handleLastDeliveryDate();
            },
        },
        "formData.expectedReceiveWarehouseCode": {
            immediate: true,
            handler(val) {
                if (!val || val === "Other")
                    return this.$set(this.formData, "theoryDeliveryDate", null);
                // 查看页不调用
                if (this.type == "query") return;
                this.handleLastDeliveryDate();
            },
        },
        datalist2: {
            immediate: true,
            handler(val) {
                console.log("datalist2", val);

                // 非查看页才调用
                if (this.type != "query") {
                    this.handleLastDeliveryDate();
                    if (!val || !val.length) {
                        // this.$set(this.formData, "expectedFinishDate", null);
                        this.$set(this.formData, "theoryDeliveryDate", null);
                        return;
                    }
                }
                this.handleExpectNeedDate();
            },
        },
        "formData.lineId": {
            immediate: true,
            handler(lineId) {
                // console.log(this.isLock);
                if (this.isLock) return;
                this.getSupplierId(lineId);
            },
        },
        "formData.supplierId": {
            immediate: true,
            handler(supplierId) {
                if (this.isLock) return;
                if (!supplierId || this.type == "query") return;
                this.getPaymentTermById();
            },
        },
        "formData.expectedFinishDate": {
            immediate: true,
            handler(expectedFinishDate) {
                if (!expectedFinishDate) return;
                // 查看页不调用
                if (this.type == "query") return;
                this.handleLastDeliveryDate();
            },
        },
        // 风险金比例
        "poOrderFk.advanceRate": {
            immediate: true,
            handler(val) {
                let amount = (val || 0) * 0.01 * (this.allamount || 0);
                this.$set(
                    this.poOrderFk,
                    "advance",
                    parseFloat(amount).toFixed(4)
                );
                console.log("风险金比例", val, amount);
            },
        },
        // 总金额
        allamount: {
            immediate: true,
            handler(val) {
                let amount =
                    (this.poOrderFk.advanceRate || 0) * 0.01 * (val || 0);
                this.$set(
                    this.poOrderFk,
                    "advance",
                    parseFloat(amount).toFixed(4)
                );
                console.log("总金额", val, amount);
            },
        },
    },
    computed: {
        ...mapState("boss", ["products"], ["userinfo"]),
        ...mapGetters("diction", [
            "getNewProductList",
            "getAllCurrency",
            "getAllSupplier",
            "getNewDifferentAllProductList",
        ]),
        ...mapGetters("dictionary", [
            "getFBBFilterDisabledAllWarehouse",
            "getFilterDisabledWarehouse",
            "getWarehouseAllList",
            "getAllProductPerson",
        ]),
        dingdingcolumns() {
            let _this = this;
            return [
                {
                    title: this.$t("boss.purchase.submission_date", {
                        defaultValue: "提交日期",
                    }),
                    key: "submitTime",
                },
                {
                    title: this.$t("boss.purchase.presenter", {
                        defaultValue: "提交人",
                    }),
                    key: "submitName",
                },
                {
                    title: this.$t("boss.purchase.DingTalk_approval", {
                        defaultValue: "钉钉审批编号",
                    }),
                    key: "businessId",
                },
                {
                    title: this.$t("boss.purchase.DingTalk_status", {
                        defaultValue: "钉钉审批状态",
                    }),
                    key: "type",
                },
                {
                    title: this.$t("boss.purchase.approval_details", {
                        defaultValue: "审批明细",
                    }),
                    width: 120,
                    render(h, { row, index }) {
                        return h("div", [
                            h(
                                "vButton",
                                {
                                    props: {
                                        theme: "primary",
                                        size: "small",
                                    },
                                    on: {
                                        click: () => {
                                            _this.seedetail(row.ourdetaillist);
                                        },
                                    },
                                },
                                this.$t("boss.purchase.click_view_details", {
                                    defaultValue: "点击查看详情",
                                })
                            ),
                        ]);
                    },
                },
            ];
        },
        getUserList() {
            return this.getAllProductPerson.filter(function (item) {
                // console.log(item)
                return item.label != "";
            });
        },
        transoprtList() {
            return [
                {
                    value: 1,
                    label: this.$t("boss.purchase.international_shipping", {
                        defaultValue: "国际海运",
                    }),
                },
                {
                    value: 2,
                    label: this.$t(
                        "boss.purchase.international_air_transport",
                        {
                            defaultValue: "国际空运",
                        }
                    ),
                },
                {
                    value: 3,
                    label: this.$t(
                        "boss.purchase.international_land_transportation",
                        {
                            defaultValue: "国际陆运",
                        }
                    ),
                },
            ];
        },
        getNewSupplier() {
            return this.getAllSupplier.filter((item) => {
                return item.attach.status === "NORMAL";
            });
        },
        mutiFileProps() {
            return {
                data: {
                    srcLabel: this.id || 0,
                    model: this.upload.model,
                    type: "other",
                },
                action:
                    process.env.VUE_APP_APIURL_UC +
                    "/api/v1/BizAttach/uploadFile",
                name: "multipartFile",
                multiple: false,
            };
        },
        getFileProps() {
            if (this.operate.downexcel) {
                return {
                    data: {
                        sourceId: this.id || 0,
                        supplierId: this.formData.supplierId || 0,
                        currency: this.formData.currency,
                    },
                    action: this.operate.actionurl,
                    name: this.operate.name,
                    download: () => {
                        this.handleWebfs(
                            process.env.VUE_APP_APIURL_BOSS +
                                this.operate.downexcel,
                            {},
                            "download"
                        );
                    },
                };
            } else {
                return {
                    data: {
                        srcLabel: this.id || 0,
                        model: "po_order",
                        type: "other",
                    },
                    action: this.operate.actionurl,
                    name: this.operate.name,
                };
            }
        },
        doccolumns() {
            // let array =
            let _this = this;
            return [
                {
                    title: this.$t("boss.purchase.attachment_name", {
                        defaultValue: "附件名称",
                    }),
                    key: "attachTitle",
                },
                {
                    title: this.$t("boss.purchase.attachment_link", {
                        defaultValue: "附件链接",
                    }),
                    key: "attachUrl",
                },
                {
                    title: this.$t("boss.purchase.operate", {
                        defaultValue: "操作",
                    }),
                    width: 120,
                    render(h, { row, index }) {
                        let delButton = "";
                        if (_this.type !== "query") {
                            delButton = h(
                                "vButton",
                                {
                                    props: {
                                        theme: "error",
                                        size: "small",
                                    },
                                    on: {
                                        click: () => {
                                            _this.remove(index);
                                        },
                                    },
                                    style: {
                                        "margin-right": "15px",
                                    },
                                },
                                this.$t("boss.purchase.delete", {
                                    defaultValue: "删除",
                                })
                            );
                        }
                        return h("div", [
                            delButton,
                            h(
                                "vButton",
                                {
                                    props: {
                                        theme: "primary",
                                        size: "small",
                                    },
                                    on: {
                                        click: () => {
                                            _this.downfile(row.attachUrl);
                                        },
                                    },
                                },
                                this.$t("boss.purchase.download", {
                                    defaultValue: "下载",
                                })
                            ),
                        ]);
                    },
                },
            ];
        },
        purchaseColumns() {
            let that = this;
            let result = [
                {
                    title: this.$t("boss.purchase.purchase_contract_name", {
                        defaultValue: "采购合同名称",
                    }),
                    key: "attachTitle",
                },
                {
                    title: this.$t("boss.purchase.contract_link", {
                        defaultValue: "合同链接",
                    }),
                    key: "attachUrl",
                },
                {
                    title: this.$t("boss.purchase.operate", {
                        defaultValue: "操作",
                    }),
                    render(h, { row, index }) {
                        let button = h("div", [
                            h(
                                "Button",
                                {
                                    props: {
                                        type: "primary",
                                        size: "small",
                                    },
                                    on: {
                                        click: () => {
                                            that.downloadAttach(0, index);
                                        },
                                    },
                                },
                                this.$t("boss.purchase.download", {
                                    defaultValue: "下载",
                                })
                            ),
                        ]);
                        if (that.type !== "query") {
                            button = h("div", [
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "primary",
                                            size: "small",
                                        },
                                        on: {
                                            click: () => {
                                                that.downloadAttach(0, index);
                                            },
                                        },
                                        style: {
                                            "margin-right": "10px",
                                        },
                                    },
                                    this.$t("boss.purchase.download", {
                                        defaultValue: "下载",
                                    })
                                ),
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "error",
                                            size: "small",
                                        },
                                        on: {
                                            click: () => {
                                                that.removePurchase(index);
                                            },
                                        },
                                    },
                                    this.$t("boss.purchase.delete", {
                                        defaultValue: "删除",
                                    })
                                ),
                            ]);
                        }
                        return h("div", [button]);
                    },
                },
            ];
            return result;
        },
        exportColumns() {
            let that = this;
            let result = [
                {
                    title: this.$t("boss.purchase.export_contract_name", {
                        defaultValue: "外销合同名称",
                    }),
                    key: "attachTitle",
                },
                {
                    title: this.$t("boss.purchase.contract_link", {
                        defaultValue: "合同链接",
                    }),
                    key: "attachUrl",
                },
                {
                    title: this.$t("boss.purchase.operate", {
                        defaultValue: "操作",
                    }),
                    render(h, { row, index }) {
                        let button = h("div", [
                            h(
                                "Button",
                                {
                                    props: {
                                        type: "primary",
                                        size: "small",
                                    },
                                    on: {
                                        click: () => {
                                            that.downloadAttach(1, index);
                                        },
                                    },
                                },
                                this.$t("boss.purchase.download", {
                                    defaultValue: "下载",
                                })
                            ),
                        ]);
                        if (that.type !== "query") {
                            button = h("div", [
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "primary",
                                            size: "small",
                                        },
                                        on: {
                                            click: () => {
                                                that.downloadAttach(1, index);
                                            },
                                        },
                                        style: {
                                            "margin-right": "10px",
                                        },
                                    },
                                    this.$t("boss.purchase.download", {
                                        defaultValue: "下载",
                                    })
                                ),
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "error",
                                            size: "small",
                                        },
                                        on: {
                                            click: () => {
                                                that.removeExport(index);
                                            },
                                        },
                                    },
                                    this.$t("boss.purchase.delete", {
                                        defaultValue: "删除",
                                    })
                                ),
                            ]);
                        }
                        return button;
                    },
                },
            ];
            return result;
        },
        detailcolumns() {
            let _this = this;
            let array = [
                {
                    width: 60,
                    type: "index",
                    title: this.$t("boss.purchase.index", {
                        defaultValue: "序号",
                    }),
                    render: (h, { index, row }) => {
                        return (
                            <div>
                                <span>{index + 1}</span>
                                <compLock
                                    v-show={row.firmStatus == 1}
                                    class="pull-right"
                                    size="20"
                                ></compLock>
                            </div>
                        );
                    },
                },
                {
                    width: 100,
                    renderHeader: (h, params) => {
                        if (this.type != "query") {
                            return h("div", [
                                h("Icon", {
                                    props: {
                                        type: "ios-medical",
                                        color: "#ed3f14",
                                    },
                                }),
                                h("strong", "ERPSKU"),
                            ]);
                        } else {
                            return h("div", [h("strong", "ERPSKU")]);
                        }
                    },
                    render(h, { row }) {
                        return (
                            <div>
                                <span>{row.erpsku}</span>
                            </div>
                        );
                    },
                },
                {
                    title: this.$t(
                        "boss.purchase.source_procurement_request_number",
                        {
                            defaultValue: "来源采购申请号",
                        }
                    ),
                    width: 100,
                    render(h, { row }) {
                        return <div>{row.poRequisitionOrderNo || "--"}</div>;
                    },
                },
                {
                    renderHeader: (h, params) => {
                        if (this.type != "query") {
                            return h("div", [
                                h("Icon", {
                                    props: {
                                        type: "ios-medical",
                                        color: "#ed3f14",
                                    },
                                }),
                                h(
                                    "strong",
                                    this.$t("boss.purchase.purchase_quantity", {
                                        defaultValue: "采购数量",
                                    })
                                ),
                            ]);
                        } else {
                            return h("div", [
                                h(
                                    "strong",
                                    this.$t("boss.purchase.purchase_quantity", {
                                        defaultValue: "采购数量",
                                    })
                                ),
                            ]);
                        }
                    },
                    render(h, { row }) {
                        return <div>{row.quantity}</div>;
                    },
                },
                {
                    title: this.$t("boss.purchase.actual_purchase_quantity", {
                        defaultValue: "实际采购数量",
                    }),
                    render(h, { row }) {
                        return <div>{row.inFactNum}</div>;
                    },
                },
                {
                    renderHeader: (h, params) => {
                        if (this.type != "query") {
                            return h("div", [
                                h("Icon", {
                                    props: {
                                        type: "ios-medical",
                                        color: "#ed3f14",
                                    },
                                }),
                                h(
                                    "strong",
                                    this.$t("boss.purchase.purchase_price", {
                                        defaultValue: "采购价格",
                                    })
                                ),
                            ]);
                        } else {
                            return h("div", [
                                h(
                                    "strong",
                                    this.$t("boss.purchase.purchase_price", {
                                        defaultValue: "采购价格",
                                    })
                                ),
                            ]);
                        }
                    },
                    render(h, { row }) {
                        return <div>{row.price}</div>;
                    },
                },
                {
                    title: this.$t("boss.purchase.actual_procurement", {
                        defaultValue: "实采总金额",
                    }),
                    render(h, { row }) {
                        return (
                            <div>
                                {!row.inFactCost && row.inFactCost !== 0
                                    ? "--"
                                    : row.inFactCost.toFixed(4)}
                            </div>
                        );
                    },
                },
                {
                    title: this.$t("boss.purchase.export_USD_price", {
                        defaultValue: "外销美金价格",
                    }),
                    render(h, { row }) {
                        return (
                            <div>
                                {row.exportPrice == 0 ? "" : row.exportPrice}
                            </div>
                        );
                    },
                },
                {
                    title: this.$t("boss.purchase.quantity_shipped", {
                        defaultValue: "已发运数量",
                    }),
                    render(h, { row }) {
                        return <div>{Number(row.shipmentQuantity || 0)}</div>;
                    },
                },
                {
                    title: this.$t("boss.purchase.unshipped_quantity", {
                        defaultValue: "未发运数量",
                    }),
                    render(h, { row }) {
                        return <div>{row.notSendNum}</div>;
                    },
                },
                {
                    title: this.$t("boss.purchase.received_quantity", {
                        defaultValue: "接收数量(可售)",
                    }),
                    render(h, { row }) {
                        return <div>{row.receiveAvailableQuantity}</div>;
                    },
                },
                {
                    title: this.$t("boss.purchase.received_quantity_not", {
                        defaultValue: "接收数量(不可售)",
                    }),
                    render(h, { row }) {
                        return <div>{row.receiveUnavailableQuantity}</div>;
                    },
                },
                {
                    title: this.$t("boss.purchase.notes", {
                        defaultValue: "备注",
                    }),
                    render(h, { row }) {
                        return <div>{row.remark}</div>;
                    },
                },
                {
                    title: this.$t(
                        "boss.purchase.cancelled_purchase_quantity",
                        {
                            defaultValue: "取消的采购数量",
                        }
                    ),
                    key: "cancelQuantity",
                },
                {
                    title: this.$t("boss.purchase.reason_cancellation", {
                        defaultValue: "取消原因",
                    }),
                    key: "cancelReason",
                },
                {
                    title: this.$t("boss.purchase.operate", {
                        defaultValue: "操作",
                    }),
                    width: 60,
                    render: (h, { row, index }) => {
                        return h("div", [
                            h(
                                "vButton",
                                {
                                    props: {
                                        type: "error",
                                        size: "small",
                                    },
                                    on: {
                                        click: () => {
                                            _this.remove2(index);
                                        },
                                    },
                                },
                                this.$t("boss.purchase.delete", {
                                    defaultValue: "删除",
                                })
                            ),
                        ]);
                    },
                },
            ];
            // 查看去掉操作字段
            if (this.type == "query") {
                array.splice(15, 1);
            }
            // 去掉外销价格
            if (this.type !== "query" || this.formData.paymentType !== "fk") {
                array.splice(7, 1);
            }
            return array;
        },
    },
    methods: {
        async getAjaxFBBFilterDisabledAllWarehouse() {
            await HttpFilterDisabledWarehouse().then(
                (res) => {
                    this.ajaxFBBFilterDisabledAllWarehouse = res.data.map(
                        (item) => {
                            return {
                                label: item.title
                                    ? `${item.code}(${item.title})`
                                    : item.code,
                                value: item.id,
                                attach: {
                                    code: item.code,
                                    warehouseType: item.warehouseType,
                                },
                            };
                        }
                    );
                    this.ajaxFBBFilterDisabledAllWarehouse.unshift({
                        label: "Other",
                        value: 0,
                        attach: {
                            warehouseType: 0,
                            code: "Other",
                        },
                    });
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
        },
        getDingData() {
            let amount = this.formData.amount;
            let currency = this.formData.currency;
            let model = "Proprietary_Procurement_More";
            if (currency == "USD") {
                if (amount < 200000) {
                    model = "Proprietary_Procurement_Less";
                }
            } else {
                if (amount * 0.1565 < 200000) {
                    model = "Proprietary_Procurement_Less";
                }
            }
            HttpGetDingLog({
                id: this.id,
                model: model,
            }).then(
                (res) => {
                    res.data.map((item) => {
                        item.entity.ourdetaillist = item.list;
                        this.dingdingData.push(item.entity);
                    });
                },
                (err) => {
                    this.$VMessage.error({
                        content: err.message,
                        duration: 30,
                        closable: true,
                    });
                }
            );
        },
        seedetail(lists) {
            const attrs = {
                columns: [
                    {
                        title: this.$t("boss.purchase.time", {
                            defaultValue: "时间",
                        }),
                        key: "createdAt",
                    },
                    {
                        title: this.$t("boss.purchase.name", {
                            defaultValue: "姓名",
                        }),
                        key: "updatedName",
                    },
                    {
                        title: this.$t("boss.purchase.state", {
                            defaultValue: "状态",
                        }),
                        key: "result",
                    },
                    {
                        title: this.$t("boss.purchase.notes", {
                            defaultValue: "备注",
                        }),
                        key: "remark",
                    },
                ],
                data: lists,
            };
            this.$VModal.default({
                title: this.$t("boss.purchase.view_details", {
                    defaultValue: "查看详情",
                }),
                width: 460,
                showFooter: false,
                render: (h) => {
                    return this.$createElement("compLog", {
                        attrs,
                    });
                },
            });
        },
        getPaymentTermById() {
            // console.log(this.getAllSupplier);
            let supplierItem = this.getAllSupplier.filter((item) => {
                return this.formData.supplierId == item.value;
            })[0];
            if (
                !supplierItem ||
                !supplierItem.attach ||
                !supplierItem.attach.paymentTermId
            )
                return;
            HttpGetPaymentDetail({
                id: supplierItem.attach.paymentTermId,
            }).then(
                (res) => {
                    // console.log(res.data.id);
                    this.paymentItem.id = res.data.id;
                    this.paymentItem.paymentName = res.data.paymentName;
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
        },
        handlePaymentDetail() {
            this.modalProps = {
                show: true,
                width: 1200,
                title: "Payment Term",
                component: "compPaymentTermDetail",
                params: this.formData.paymentTermId,
                querytype: "query",
                showFooter: false,
            };
        },
        handleChoosePayment() {
            this.modalProps = {
                show: true,
                width: 900,
                title: this.$t("boss.purchase.select_Payment_Term", {
                    defaultValue: "查看详情",
                }),
                component: "compPaymentTermList",
                showFooter: false,
                on: {
                    "on-close": () => {
                        // console.log('on-close');
                        this.modalProps.show = false;
                    },
                    "on-confirm": (data) => {
                        // console.log('data', data);
                        this.paymentItem = data;
                        this.modalProps.show = false;
                    },
                },
            };
        },
        // 重新计算
        async reComputed() {
            this.modalProps = {
                title: this.$t("boss.purchase.recalculate_theoretical", {
                    defaultValue: "重新计算理论交货日期",
                }),
                showDesc: true,
                alert: "warning",
                show: true,
                params: {
                    ids: this.id ? this.id : this.activeid,
                },
                ajaxRequest: HttpBatchLastDate,
                callback: (res) => {
                    this.$VMessage.success(res.message);
                    this.update();
                },
            };
        },
        async handleExpectNeedDate() {
            if (this.type === "query" || this.isHasDate) return;
            // console.log("datalist2", this.datalist2);
            // 申请单表id数组
            let idList = this.datalist2
                .filter((item) => {
                    return !!item.poRequistionOrderItemId;
                })
                .map((item) => {
                    return item.poRequistionOrderItemId;
                });
            if (!idList.length)
                // return this.$set(this.formData, "expectedFinishDate", null);
                return;
            await HttpGetExpectedDate({
                // port: portName,
                // warehouseCode: warehouseCode,
                prItemIds: idList,
            }).then(
                (res) => {
                    // if (!res.message) return this.$set(this.formData, "expectedFinishDate", null);
                    if (!res.message) return;
                    this.$set(this.formData, "expectedFinishDate", res.message);
                    // console.log("res", this.formData.expectedFinishDate);
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
        },
        async handleLastDeliveryDate() {
            // console.log("datalist2", this.datalist2);
            // 港口
            let portName = this.formData.expectedDeliveryPort;
            // 仓库Code
            let warehouseCode = this.formData.expectedReceiveWarehouseCode;
            // 预计交货日期
            let expectedFinishDate = this.formData.expectedFinishDate;
            // 申请单表id数组
            let idList = this.datalist2
                .filter((item) => {
                    return !!item.poRequistionOrderItemId;
                })
                .map((item) => {
                    return item.poRequistionOrderItemId;
                });
            // console.log({
            //     port: portName,
            //     warehouseCode: warehouseCode,
            //     prItemIds: idList,
            // });
            if (
                !portName ||
                !warehouseCode ||
                warehouseCode === "Other" ||
                !expectedFinishDate
                // || !idList.length
            )
                // return this.$set(this.formData, "theoryDeliveryDate", null);
                return;
            await HttpGetLastDeliveryDate({
                port: portName,
                warehouseCode: warehouseCode,
                prItemIds: idList,
                expectedFinishDate: this.formData.expectedFinishDate,
            })
                .then(
                    (res) => {
                        // console.log("res", res);
                        if (!res.message)
                            return this.$set(
                                this.formData,
                                "theoryDeliveryDate",
                                null
                            );
                        this.$set(
                            this.formData,
                            "theoryDeliveryDate",
                            res.message
                        );
                    },
                    (err) => {
                        // console.log(err);
                        this.$VMessage.error(err.message);
                    }
                )
                .finally(() => {
                    this.hasRequest = true;
                });
        },
        async getPortList() {
            await HttpGetSystemPortList({
                page: 1,
                rows: 1000,
            }).then(
                (res) => {
                    this.portList = res.data.content.map((item) => {
                        return {
                            value: item.title,
                            label: item.title,
                            attach: {
                                ...item,
                            },
                        };
                    });
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
        },
        uploaddetail() {
            this.handleWebfs(
                process.env.VUE_APP_APIURL_BOSS + "/api/v2/po/exportItemDetail",
                { contextId: global.SYSID, id: this.id },
                "download"
            );
        },
        reduceNumber() {
            this.modalProps = {
                show: true,
                title: this.$t("boss.purchase.reduce_procurement", {
                    defaultValue: "减少采购数量",
                }),
                showFooter: false,
                width: 800,
                component: reduceNumberComponent,
                type: 1,
                id: this.id,
                dataList: this.datalist2,
                on: {
                    "on-success": () => {
                        this.update();
                    },
                },
            };
        },
        autoReduceNumber() {
            this.modalProps = {
                show: true,
                title: this.$t("boss.purchase.click_reduction", {
                    defaultValue: "一键减少采购数量",
                }),
                showFooter: false,
                width: 800,
                component: reduceNumberComponent,
                type: 2,
                id: this.id,
                dataList: this.datalist2,
                on: {
                    "on-success": () => {
                        this.update();
                    },
                },
            };
        },
        changePayment() {
            this.formData.paymentType == "fk"
                ? (this.formData.currency = "CNY")
                : "";
            if (
                this.formData.paymentType == "fk" ||
                this.formData.paymentType == "payment"
            ) {
                this.$set(this.formData, "isNeedInspect", 1);
            } else this.$set(this.formData, "isNeedInspect", 0);
            if (
                (this.formData.paymentType == "fk" ||
                    this.formData.paymentType == "payment") &&
                global.SYSID == 1
            ) {
                this.$set(this.formData, "poPurchaserId", 1);
            } else this.$set(this.formData, "poPurchaserId", null);
        },
        closemodalprops() {
            this.$emit("on-openCloseable");
            this.modalProps = {};
        },
        getRate(funderId) {
            let rateItem = this.funderList.filter((item) => {
                return funderId === item.id;
            })[0];
            console.log("rateItem", rateItem);
            // console.log(rateItem,'rateItem')
            // 外销合同天数修改
            this.exportContractDayList = this.arrayUnique(
                rateItem.protocolDetailListMap,
                "protocolItemId"
            );
            if (rateItem) {
                this.poOrderFk.exchangeRate = rateItem.rate;
                // 新增字段
                this.poOrderFk.funderName = rateItem.funderName;
                this.poOrderFk.funderNameEn = rateItem.funderNameEn;
                this.poOrderFk.funderAddress = rateItem.address;
                this.poOrderFk.funderAddressEn = rateItem.addressEn;
                this.poOrderFk.funderContactPhone = rateItem.phone;
                this.poOrderFk.funderContactName = rateItem.contactName;
                // 资方信息自动带入-钉钉需求
                this.poOrderFk.cnyPaymentReceiveBank = rateItem.bankName;
                this.poOrderFk.cnyPaymentReceiveAccountNo = rateItem.bankCode;
                this.poOrderFk.usdPaymentReceiveBank = rateItem.bankNameEn;
                this.poOrderFk.usdPaymentReceiveAccountNo = rateItem.bankCodeEn;
                this.poOrderFk.cnyPaymentReceiveBankAddress =
                    rateItem.bankAddress;
                this.poOrderFk.usdPaymentReceiveSwiftCode =
                    rateItem.receivingName;
                this.rateDisabled = true;
            } else {
                this.poOrderFk.rate = "";
            }
        },
        getProtocolItemId(protocolItemId) {
            this.poOrderFk.protocolItemId = protocolItemId;
        },
        getFunderName(value) {
            let funder = this.funderList.filter((item) => {
                return value === item.id;
            })[0];
            if (funder) return funder.funderName;
            return "--";
        },
        downloadAttach(type, index) {
            let fileUrl = "";
            switch (type) {
                // 采购合同
                case 0:
                    fileUrl = this.purchaseList[index].attachUrl;
                    break;
                // 外销合同
                case 1:
                    fileUrl = this.exportList[index].attachUrl;
                    break;
            }
            this.handleWebfs(fileUrl, {}, "download");
        },
        async removePurchase(index) {
            await this.delAttach(this.purchaseList[index].attachId, "purchase");
            this.purchaseList.splice(index, 1);
        },
        async removeExport(index) {
            await this.delAttach(this.exportList[index].attachId, "export");
            this.exportList.splice(index, 1);
        },
        cancelMutiUpload() {
            this.upload.show = false;
        },
        async delAttach(id, type) {
            // 新增时删除附件用另外的接口
            if (this.type === "add") {
                await HttpDelAttachNew({
                    id: id,
                }).then(
                    (res) => {
                        this.$VMessage.success(res.message);
                    },
                    (err) => {
                        this.$VMessage.error({
                            content: err.message,
                            duration: 30,
                            closable: true,
                        });
                    }
                );
            }
            // 编辑
            else {
                let httpDelFunc = HttpDelAttachPurchase;
                if (type === "export") {
                    httpDelFunc = HttpDelAttachExport;
                }
                await httpDelFunc({
                    id: this.id || 0,
                    attachId: id,
                }).then(
                    (res) => {
                        this.$VMessage.success(res.message);
                    },
                    (err) => {
                        this.$VMessage.error({
                            content: err.message,
                            duration: 30,
                            closable: true,
                        });
                    }
                );
            }
        },
        purchaseUpload() {
            this.upload = {
                show: true,
                title: this.$t("boss.purchase.purchase_contract_upload", {
                    defaultValue: "采购合同上传",
                }),
                model: "po_order_fk_purchase",
            };
        },
        exportUpload() {
            this.upload = {
                show: true,
                title: this.$t("boss.purchase.upload_export_contract", {
                    defaultValue: "外销合同上传",
                }),
                model: "po_order_fk_export",
            };
        },
        uploadSuccess(res) {
            let list = [];
            // 采购合同
            if (this.upload.model === "po_order_fk_purchase") {
                list = this.purchaseList;
            }
            // 外销合同
            else {
                list = this.exportList;
            }
            res.items.map((item) => {
                list.push(item);
            });
            this.cancelMutiUpload();
        },
        getTransport(value) {
            let result =
                this.transoprtList.filter((item) => {
                    return value === item.value;
                })[0] || undefined;
            if (!result) return "--";
            return result.label;
        },
        addnotes(type) {
            this.$emit("on-closeCloseable");
            switch (type) {
                case "addnotes":
                    this.modalProps = {
                        show: true,
                        alert: "error",
                        title: this.$t("boss.purchase.add_note", {
                            defaultValue: "添加备注",
                        }),
                        width: 460,
                        params: { ids: this.id },
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "remark",
                                span: 24,
                                label: this.$t("boss.purchase.reason_remark", {
                                    defaultValue: "备注原因",
                                }),
                                required: false,
                            },
                        ],
                        ajaxRequest: HttpGetOrderNotes,
                        callback: () => {
                            this.modalProps.show = false;
                            this.update();
                        },
                    };
                    break;
                case "auditingpass":
                    this.modalProps = {
                        show: true,
                        alert: "primary",
                        title: this.$t("boss.purchase.approved", {
                            defaultValue: "审核通过",
                        }),
                        width: 460,
                        params: { ids: this.id, orderStatus: "auditing_pass" },
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "remark",
                                span: 24,
                                label: this.$t("boss.purchase.reason_remark", {
                                    defaultValue: "备注原因",
                                }),
                                required: false,
                            },
                        ],
                        ajaxRequest: HttpGetAuditing,
                        callback: () => {
                            this.update();
                        },
                    };
                    break;
                case "submitbox":
                    this.modalProps = {
                        show: true,
                        alert: "error",
                        title: this.$t("boss.purchase.confirm_documents", {
                            defaultValue: "确认单据",
                        }),
                        width: 460,
                        params: { ids: this.id },
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "remark",
                                span: 24,
                                label: this.$t("boss.purchase.reason_remark", {
                                    defaultValue: "备注原因",
                                }),
                                required: false,
                            },
                        ],
                        ajaxRequest: HttpGetOrderSubmit,
                        callback: () => {
                            this.update();
                        },
                    };
                    break;
                case "delivery":
                    this.modalProps = {
                        title: this.$t("boss.purchase.delivery", {
                            defaultValue: "交货",
                        }),
                        show: true,
                        width: 1200,
                        component: "delivery",
                        activeid: this.id,
                        querytype: "delivery",
                        showFooter: false,
                    };
                    break;
                case "inspection":
                    this.modalProps = {
                        title: this.$t("boss.purchase.inspection", {
                            defaultValue: "验货",
                        }),
                        show: true,
                        width: 1200,
                        component: "comInspection",
                        activeid: this.id,
                        showFooter: false,
                    };
                    break;
                case "close":
                    this.modalProps = {
                        show: true,
                        alert: "error",
                        title: this.$t("boss.purchase.complete", {
                            defaultValue: "完成",
                        }),
                        width: 460,
                        params: { ids: this.id },
                        desc: this.$t("boss.purchase.after_completion", {
                            defaultValue:
                                "完成后，采购未发运数量清零，请谨慎操作！",
                        }),
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "remark",
                                span: 24,
                                label: this.$t("boss.purchase.reason_remark", {
                                    defaultValue: "备注原因",
                                }),
                                required: false,
                            },
                        ],
                        ajaxRequest: HttpGetOrderClose,
                        callback: () => {
                            this.update();
                        },
                    };
                    break;
                case "auditingrefused":
                    this.modalProps = {
                        show: true,
                        alert: "error",
                        title: this.$t("boss.purchase.review_rejected", {
                            defaultValue: "审核驳回",
                        }),
                        width: 460,
                        params: {
                            ids: this.id,
                            orderStatus: "auditing_refused",
                        },
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "remark",
                                span: 24,
                                label: this.$t("boss.purchase.reason_remark", {
                                    defaultValue: "备注原因",
                                }),
                                required: false,
                            },
                        ],
                        ajaxRequest: HttpGetAuditing,
                        callback: () => {
                            this.update();
                        },
                    };
                    break;
                case "contractSignDate":
                    this.modalProps = {
                        show: true,
                        alert: "success",
                        title: this.$t("boss.purchase.contract_signing", {
                            defaultValue: "合同签订日期",
                        }),
                        showDesc: false,
                        width: 460,
                        params: { id: this.id },
                        formdata: [
                            {
                                tag: "vDatepicker",
                                key: "contractSignDate",
                                props: { format: "yyyy-mm-dd" },
                                span: 24,
                                label: this.$t(
                                    "boss.purchase.contract_signing",
                                    {
                                        defaultValue: "合同签订日期",
                                    }
                                ),
                            },
                            {
                                tag: "vTextarea",
                                key: "remark",
                                span: 24,
                                label: this.$t("boss.purchase.notes", {
                                    defaultValue: "备注",
                                }),
                                required: false,
                            },
                        ],
                        ajaxRequest: HttpGetContractSignDate,
                        callback: () => {
                            this.update();
                        },
                    };
                    break;
                case "expectedInspectDate":
                    this.modalProps = {
                        show: true,
                        alert: "info",
                        title: this.$t(
                            "boss.purchase.expected_inspection_date",
                            {
                                defaultValue: "预计验货日期",
                            }
                        ),
                        showDesc: false,
                        width: 460,
                        params: { id: this.id },
                        formdata: [
                            {
                                tag: "vDatepicker",
                                key: "expectedInspectDate",
                                props: { format: "yyyy-mm-dd" },
                                span: 24,
                                label: this.$t(
                                    "boss.purchase.expected_inspection_date",
                                    {
                                        defaultValue: "预计验货日期",
                                    }
                                ),
                            },
                            {
                                tag: "vTextarea",
                                key: "remark",
                                span: 24,
                                label: this.$t("boss.purchase.notes", {
                                    defaultValue: "备注",
                                }),
                                required: false,
                            },
                        ],
                        ajaxRequest: HttpGetExpectedInspectDate,
                        callback: () => {
                            this.update();
                        },
                    };
                    break;
                case "expectedFinishDate":
                    let expecte = this.formData.expectedFinishDate;
                    this.modalProps = {
                        show: true,
                        alert: "primary",
                        title: this.$t("boss.purchase.expected_shelf_life", {
                            defaultValue: "预计上架时间",
                        }),
                        showDesc: false,
                        width: 460,
                        params: { id: this.id },
                        formdata: [
                            {
                                label: this.$t(
                                    "boss.purchase.current_estimated_shelf_life",
                                    {
                                        defaultValue: "现有预计上架时间",
                                    }
                                ),
                                valueText: expecte,
                                span: 24,
                                query: true,
                            },
                            {
                                tag: "vDatepicker",
                                key: "expectedFinishDate",
                                props: { format: "yyyy-mm-dd" },
                                span: 24,
                                label: this.$t(
                                    "boss.purchase.modify_estimated_shelf_life",
                                    {
                                        defaultValue: "修改预计上架时间",
                                    }
                                ),
                            },
                            {
                                tag: "vTextarea",
                                key: "remark",
                                span: 24,
                                label: this.$t("boss.purchase.notes", {
                                    defaultValue: "备注",
                                }),
                                required: false,
                            },
                        ],
                        ajaxRequest: HttpGetExpectedFinishDate,
                        callback: () => {
                            this.update();
                        },
                    };
                    break;
                case "expectedDeliveryDate":
                    this.modalProps = {
                        show: true,
                        alert: "info",
                        title: this.$t(
                            "boss.purchase.estimated_delivery_date_a",
                            {
                                defaultValue: "录入最新预计交期",
                            }
                        ),
                        showFooter: false,
                        width: 460,
                        id: this.id,
                        expectedFinishDate: this.formData.expectedFinishDate,
                        component: "compexpecteddate",
                        on: {
                            "on-update": () => {
                                this.update();
                            },
                        },
                    };
                    break;
                case "cancelSubmit":
                    this.modalProps = {
                        show: true,
                        title: this.$t("boss.purchase.withdraw_submission", {
                            defaultValue: "撤回提交",
                        }),
                        alert: "warning",
                        showFooter: false,
                        width: 460,
                        params: {
                            ids: this.id,
                        },
                        formdata: [
                            {
                                label: this.$t("boss.purchase.notes", {
                                    defaultValue: "备注",
                                }),
                                key: "remark",
                                tag: "vTextarea",
                                span: 24,
                                required: false,
                            },
                        ],
                        ajaxRequest: HttpBackSubmit,
                        callback: () => {
                            this.update();
                        },
                    };
                    break;
            }
        },
        getBuyMode(type, status) {
            switch (status) {
                case "paymentType":
                    return (
                        this.buyModeList.filter((item) => {
                            return item.value === type;
                        })[0] || {}
                    );
                    break;
                case "poUserId":
                    return (
                        this.getUserList.filter((item) => {
                            return item.value === type;
                        })[0] || {}
                    );
                    break;
                case "poPurchaserId":
                    return (
                        this.purchaserList.filter((item) => {
                            return item.id === type;
                        })[0] || {}
                    );
                    break;
            }
        },
        downfile(url) {
            this.handleWebfs(url, {}, "download");
        },
        getSupplierId(lineid) {
            // console.log(lineid)
            let arr = this.getNewProductList.filter((item) => {
                return item.value == lineid;
            });
            // console.log(arr)
            this.$set(this.formData, "supplierId", arr[0].attach.supplierId);
            this.$set(this.formData, "paymentType", arr[0].attach.paymentType);
            // this.formData.supplierId = arr[0].attach.supplierId;
            // this.formData.paymentType = arr[0].attach.paymentType;

            this.getPayment(this.formData.supplierId);
        },
        getPayment(supplierId) {
            // console.log(supplierId)
            let supplier = this.getAllSupplier.filter((item) => {
                return item.value === supplierId;
            })[0];
            // console.log(supplier,'898989898989')
            this.formData.paymentDay =
                supplier.attach.paymentDay === null
                    ? ""
                    : supplier.attach.paymentDay;
            this.formData.paymentExplain = supplier.attach.paymentExplain;
            if (supplier.attach.paymentRate) {
                this.formData.paymentRate = supplier.attach.paymentRate;
            } else {
                this.formData.paymentRate = "";
            }
        },
        getNewWarehouseCode(id) {
            // console.log(id,'8888')
            if (id == 0) return;
            this.ajaxFBBFilterDisabledAllWarehouse.map((item) => {
                if (id === item.value) {
                    this.formData.expectedReceiveWarehouseCode =
                        item.attach.code;
                }
            });
            this.getChannel(this.formData.expectedReceiveWarehouseCode);
        },
        getSupplier(sulierid) {
            // console.log(sulierid,'2222222')
            let itemarr =
                this.getAllSupplier.filter((item) => {
                    return item.value == sulierid;
                })[0] || {};
            if (!itemarr || !itemarr.attach) return "--";
            return `${itemarr.label}(${itemarr.attach.code})` || "--";
        },
        getLineName(id) {
            let json =
                this.getNewDifferentAllProductList.filter((item) => {
                    return item.value == id;
                })[0] || {};
            return json.label || "--";
        },
        getstatus(type) {
            switch (type) {
                case "draft":
                    return this.$t("boss.purchase.draft", {
                        defaultValue: "草稿",
                    });
                    break;
                case "submit":
                    return this.$t("boss.purchase.submitted", {
                        defaultValue: "已提交",
                    });
                    break;
                case "auditing_pass":
                    return this.$t("boss.purchase.approved", {
                        defaultValue: "审核通过",
                    });
                    break;
                case "finished":
                    return this.$t("boss.purchase.completed", {
                        defaultValue: "已完成",
                    });
                    break;
                case "canceled":
                    return this.$t("boss.purchase.cancelled", {
                        defaultValue: "已取消",
                    });
                    break;
                case "auditing_refused":
                    return this.$t("boss.purchase.review_rejected", {
                        defaultValue: "审核驳回",
                    });
                    break;
            }
        },
        showcheck() {
            this.handle = {
                show: true,
                title: this.$t("boss.purchase.procurement_request_list", {
                    defaultValue: "采购申请列表",
                }),
                component: "compCheck",
                width: 1000,
                supplierId: this.formData.supplierId,
                currency: this.formData.currency,
                lineId: this.formData.lineId,
                on: {
                    "on-updatecheck": (val) => {
                        // console.log(12312312,val)
                        this.updatecheck(val);
                    },
                },
            };
        },
        remoteMethod1(query) {
            this.loading1 = true;
            HttpGetErpsku({
                "search[CN_erpSku]": query,
                rows: 10,
                "search[EQ_lineId]": this.formData.lineId,
                "search[EQ_enable]": 1,
                "search[EQ_status]": 0,
            }).then((res) => {
                // console.log(res)
                this.loading1 = false;
                this.erpSkusList = res.data.content.map((item) => {
                    return {
                        name: item.erpSku,
                        id: item.id,
                        lineId: item.lineId,
                    };
                });
            });
        },
        getProductId(skuid) {
            // console.log(skuid)
            if (skuid) {
                this.proidarr = this.erpSkusList.filter((item) => {
                    return item.name == skuid;
                });
                HttpGetProductPrice({
                    productId: this.proidarr[0].id,
                    supplierId: this.formData.supplierId,
                    currency: this.formData.currency,
                }).then(
                    (res) => {
                        this.appacount = res.data || 0;
                    },
                    (err) => {
                        this.$VMessage.error({
                            content: err.message,
                            duration: 30,
                            closable: true,
                        });
                    }
                );
            }
            // console.log(this.proidarr,'ddddd')
        },
        adddocument(type) {
            this.handle = {
                show: true,
                title: this.$t("boss.purchase.add_attachment", {
                    defaultValue: "添加附件",
                }),
                width: 460,
                component: "compMutiUpload",
                data: {
                    srcLabel: this.id || 0,
                    model: "po_order",
                    type: "other",
                },
                showFooter: false,
                action:
                    process.env.VUE_APP_APIURL_UC +
                    "/api/v1/BizAttach/uploadFile",
                name: "multipartFile",
                multiple: true,
                beforeUpload: (fileList) => {
                    if (fileList.length > 5) {
                        this.$VMessage.error(
                            this.$t("boss.purchase.package_and_upload", {
                                defaultValue: "附件数量过多，请打包后上传",
                            })
                        );
                        return false;
                    } else {
                        return true;
                    }
                },
                on: {
                    "on-success": (res) => {
                        // console.log(res,'333333333')
                        let flag = false;
                        if (res.items.length + this.docList.length > 5) {
                            this.$VMessage.error(
                                this.$t("boss.purchase.package_and_upload", {
                                    defaultValue: "附件数量过多，请打包后上传",
                                })
                            );
                            flag = true;
                        }
                        res.items.map((item) => {
                            if (flag) {
                                this.remove(item.attachId, true);
                            } else {
                                this.docList.push(item);
                            }
                        });
                        if (type == "headdoc") {
                            HttpUpdateDoc({
                                id: this.id,
                                meta: JSON.stringify({
                                    items: this.docList,
                                    opAt: this.docList[0]
                                        ? this.docList[0].attachOpAt
                                        : "",
                                    organizationId: global.SYSID,
                                }),
                            });
                        }
                        this.handle = {};
                    },
                    "on-cancel": () => {
                        this.handle = {};
                    },
                },
            };
        },
        // 点击导入按钮
        importExcel() {
            this.operate = {
                show: true,
                title: "导入",
                actionurl:
                    process.env.VUE_APP_APIURL_BOSS +
                    "/api/v2/po/importItemExcel",
                boxtype: "importexcel",
                name: "excelFile",
                downexcel: "/api/v2/po/downItemExcel",
            };
        },
        alertbox() {
            this.modalProps = {
                show: true,
                alert: "error",
                title: this.$t("boss.purchase.clear_all", {
                    defaultValue: "全部清除",
                }),
                width: 460,
                desc: this.$t("boss.purchase.clear_all_data_table", {
                    defaultValue: "是否清除表格内所有数据?",
                }),
                ajaxRequest: async () => {
                    // console.log(2323232323)
                    this.datalist2 = [];
                    this.allnumber = 0;
                    this.allacount = 0;
                    this.allamount = 0;
                    return {
                        message: this.$t("global.common.haveto_empty", {
                            defaultValue: "已清空",
                        }),
                    };
                },
            };
        },
        async adddetail() {
            const valid = await this.$refs.applicateform.validate();
            if (!valid) return;
            if (!this.apperpsku) {
                this.$VMessage.error(
                    this.$t("global.common.required_information", {
                        defaultValue: "请填写必须信息再点击添加",
                    })
                );
                return;
            }
            let itemdata = {
                productId: this.proidarr[0].id,
                lineId: this.proidarr[0].lineId,
                erpsku: this.apperpsku,
                quantity: Number(this.appnumber),
                price: Number(this.appacount),
                remark: this.appremark,
                inFactAmount: 0,
                inFactCost: 0,
            };
            // console.log(itemdata,'88888')
            if (this.datalist2.length < 1) {
                this.datalist2.push(itemdata);
                this.$set(this.$data, "datalist2", this.datalist2);
            } else {
                let flag = false;
                let additemIndex = null;

                // console.log(this.datalist2,'99999')
                // console.log(this.datalist2[0],itemdata.lineId,'9999955555')
                if (this.datalist2[0].lineId == itemdata.lineId) {
                    this.datalist2.map((json, index) => {
                        if (json.erpsku == itemdata.erpsku) {
                            if (json.poRequisitionOrderNo) {
                                additemIndex = null;
                            } else {
                                additemIndex = index;
                            }
                        }
                    });
                } else {
                    this.$VMessage.error(
                        this.$t("global.common.ERPSKU_project", {
                            defaultValue:
                                "添加的ERPSKU的项目与table里面的ERPSKU的项目不统一，请重新选择！",
                        })
                    );
                    return;
                }
                // console.log(additemIndex,'additemIndex')
                if (additemIndex != null) {
                    if (this.datalist2[additemIndex].price == itemdata.price) {
                        this.datalist2[additemIndex].quantity +=
                            itemdata.quantity;
                    } else {
                        this.$VMessage.error(
                            this.$t("global.common.added_ERPSKU", {
                                defaultValue:
                                    "添加的ERPSKU的价格与table里面的ERPSKU的价格不同，请重新填写！",
                            })
                        );
                        return;
                    }
                } else {
                    this.datalist2.push(itemdata);
                }
            }

            this.getallnumber();
            // 采购的内容进行清空
            this.apperpsku = "";
            this.appnumber = 1;
            this.appacount = 0;
            this.appremark = "";
        },
        getallnumber() {
            let accounts = 0;
            let amounts = 0;
            let inFactAmount = 0;
            let usdAmount = 0;
            let skuArr = [];
            this.datalist2.map((item) => {
                // 实际采购数量
                item.inFactNum = Number(
                    item.quantity -
                        (item.cancelQuantity ? item.cancelQuantity : 0)
                );
                // 实采总金额
                item.inFactCost = Number(
                    item.price *
                        Number(
                            item.quantity -
                                (item.cancelQuantity ? item.cancelQuantity : 0)
                        )
                );
                // 未发运数量
                item.notSendNum =
                    Number(
                        item.quantity -
                            (item.cancelQuantity ? item.cancelQuantity : 0) -
                            item.shipmentQuantity
                    ) > 0
                        ? Number(
                              item.quantity -
                                  (item.cancelQuantity
                                      ? item.cancelQuantity
                                      : 0) -
                                  item.shipmentQuantity
                          )
                        : 0;
                skuArr.push(item.erpsku);
                accounts += item.inFactNum;
                amounts += Number(item.price * item.quantity);
                inFactAmount += item.inFactCost;
                usdAmount += (item.exportPrice || 0) * item.inFactNum;
            });
            this.allnumber = new Set(skuArr).size;
            this.allacount = accounts;
            this.allamount = inFactAmount.toFixed(4);
            this.usdAmount = usdAmount.toFixed(4);
        },
        getChannel(wacode) {
            // console.log(wacode)
            let wajsonone =
                this.ajaxFBBFilterDisabledAllWarehouse.filter((item) => {
                    return item.attach.code == wacode;
                })[0] || {};
            // console.log(wajsonone,'111111')
            if (wajsonone.attach.warehouseType !== 4) {
                this.showaccount = false;
                return;
            }
            let wareId = wajsonone.value;
            this.showaccount = true;
            HttpFindByOrgIdAndOrgWarehouseId({
                orgId: global.SYSID,
                orgWarehouseId: wareId,
            }).then(
                (res) => {
                    this.channelList = [];
                    this.channelList = res.data;
                },
                (err) => {
                    this.$$VMessage.error(err.message);
                }
            );
        },
        async getPaymentTerm() {
            await HttpGetPaymentByOrgId().then(
                (res) => {
                    this.paymentList = res.data;
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
        },
        async update() {
            if (this.querytype) {
                this.id = this.activeid;
                this.type = this.querytype;
            } else {
                this.id = this.$route.query.id;
                this.type = this.type;
            }
            await HttpGetPurchaserList().then(
                (res) => {
                    this.purchaserList = res.data;
                },
                (err) => {
                    this.$VMessage.error({
                        content: err.message,
                        duration: 30,
                        closable: true,
                    });
                }
            );
            // 默认获取当天的合同签订日期
            // contractSignDate
            this.formData.contractSignDate = this.getDay(0);

            await HttpFindProvidersByOrg().then(
                (res) => {
                    // console.log(res,'23423423');
                    this.funderList = res.data || [];
                },
                (err) => {
                    this.funderList = [];
                }
            );

            if (this.type == "add") return;
            this.loading = true;
            // 详情
            if (this.type != "add") {
                await this.getPaymentTerm();
                await HttpGetOrderOne({
                    id: this.id,
                }).then(
                    (res) => {
                        // console.log(res,'9889')
                        this.loading = false;
                        this.formData = res.data;
                        if (this.formData.expectedFinishDate)
                            this.isHasDate = true;
                        this.paymentItem =
                            this.paymentList.filter((item) => {
                                return item.id == this.formData.paymentTermId;
                            })[0] || {};
                        this.getBuyTypeLabel(this.formData.buyerType);
                        this.updatestatus = [
                            {
                                label: this.$t("boss.purchase.draft", {
                                    defaultValue: "草稿",
                                }),
                                value: this.formData.createdAt.split(" ")[0],
                            },
                            {
                                label: this.$t("boss.purchase.submitted", {
                                    defaultValue: "已提交",
                                }),
                                value: this.formData.submitDate,
                            },
                            {
                                label: this.$t("boss.purchase.approved", {
                                    defaultValue: "审核通过",
                                }),
                                value: this.formData.auditingDate,
                            },
                            {
                                label: this.$t(
                                    "boss.purchase.create_inventory_plan",
                                    { defaultValue: "创建入库计划" }
                                ),
                                value: this.formData.firstShipmentDate,
                            },
                            {
                                label: this.$t("boss.purchase.inspection", {
                                    defaultValue: "验货",
                                }),
                                value: this.formData.inspectDate,
                            },
                            {
                                label: this.$t("boss.purchase.delivery", {
                                    defaultValue: "交货",
                                }),
                                value: this.formData.firstDeliverDate,
                            },
                            {
                                label: this.$t("boss.purchase.receive", {
                                    defaultValue: "接收",
                                }),
                                value: this.formData.firstReceiveDate,
                            },
                            {
                                label: this.$t("boss.purchase.completed", {
                                    defaultValue: "已完成",
                                }),
                                value: this.formData.finishDate,
                            },
                        ];
                        if (this.formData.poUserId == 0) {
                            this.formData.poUserId =
                                this.$store.state.userinfo.id;
                        }
                        this.poOrderFk = res.data.poOrderFk
                            ? res.data.poOrderFk
                            : {};
                        this.datalist2 = res.data.poOrderItem;
                        this.purchaseList = res.data.poOrderFk
                            ? JSON.parse(
                                  res.data.poOrderFk.purchaseContractMeta
                              ).items
                            : [];
                        this.exportList = res.data.poOrderFk
                            ? JSON.parse(res.data.poOrderFk.exportContractMeta)
                                  .items
                            : [];
                        this.datalist2.map((item) => {
                            item.lineId = res.data.lineId;
                        });
                        this.getallnumber();
                        this.formData.paymentRate =
                            res.data.paymentRate === null
                                ? ""
                                : res.data.paymentRate;
                        this.formData.paymentDay =
                            res.data.paymentDay === null
                                ? ""
                                : res.data.paymentDay;

                        this.docList = res.data.meta
                            ? JSON.parse(res.data.meta).items
                            : [];

                        this.getNewWarehouseCode(
                            res.data.expectedReceiveWarehouseId
                        );

                        // 入库计划单获取
                        let arrNos = [];
                        (res.data.inboundPlanReceiveList || []).map((item) => {
                            let jsonone =
                                item.inboundPlanOrderNo +
                                " (" +
                                this.getinboundStatus(
                                    item.inboundPlanOrderStatus
                                ) +
                                ")";
                            arrNos.push(jsonone);
                        });
                        this.stringNos = arrNos.join(",");

                        // 展示渠道选择
                        if (this.formData.expectedReceiveWarehouseCode != "") {
                            // console.log(this.formData.expectedReceiveWarehouseCode)
                            let channelone =
                                this.ajaxFBBFilterDisabledAllWarehouse.filter(
                                    (json) => {
                                        return (
                                            json.attach.code ==
                                            this.formData
                                                .expectedReceiveWarehouseCode
                                        );
                                    }
                                )[0] || {};
                            if (channelone.attach.warehouseType == 4) {
                                this.showaccount = true;
                            } else this.showaccount = false;

                            if (this.type == "edit") {
                                this.getChannel(
                                    this.formData.expectedReceiveWarehouseCode
                                );
                            }
                        }
                    },
                    (err) => {
                        this.errorMessage(err.message);
                        this.loading = false;
                    }
                );

                // 日志
                if (this.type == "query") {
                    console.log("调用日志接口");
                    HttpSysOpLog({
                        "search[EQ_opDataId]": this.id,
                        "search[EQ_opModel]": "po_order",
                    }).then(
                        (res) => {
                            this.logList = res.data.content;
                            this.loading = false;
                        },
                        (err) => {
                            this.errorMessage(err.message);
                            this.loading = false;
                        }
                    );
                    this.getDingData();
                }
            }
            if (this.type == "edit") {
                this.editshow = true;
                this.showwarehouse = true;
            }

            this.isLock = false;
        },
        getinboundStatus(inboundStus) {
            switch (inboundStus) {
                case 0:
                    return this.$t("fbb.inbound.draft", {
                        defaultValue: "草稿",
                    });
                    break;
                case 5:
                    return this.$t("fbb.inbound.check_pending", {
                        defaultValue: "待审核",
                    });
                    break;
                case 6:
                    return this.$t("fbb.inbound.approval_back", {
                        defaultValue: "审批拒回",
                    });
                    break;
                case 8:
                    return this.$t("fbb.inbound.for_packing", {
                        defaultValue: "待装箱",
                    });
                    break;
                case 10:
                    return this.$t("fbb.inbound.send_goods", {
                        defaultValue: "待发货",
                    });
                    break;
                case 20:
                    return this.$t("fbb.inbound.stock_pending", {
                        defaultValue: "待入库",
                    });
                    break;
                case 25:
                    return this.$t("fbb.inbound.inthe_library", {
                        defaultValue: "入库中",
                    });
                    break;
                case 70:
                    return this.$t("global.common.finished", {
                        defaultValue: "已完成",
                    });
                    break;
                case 100:
                    return this.$t("global.common.canceled", {
                        defaultValue: "已取消",
                    });
                    break;
            }
        },
        updatecheck(data) {
            // console.log(data);
            if (data.datalist.length < 1) {
                this.$VMessage.error(
                    this.$t("boss.purchase.quantity_or_purchase", {
                        defaultValue: "转采购数量或采购价格必填",
                    })
                );
                return;
            }
            this.applicateOrders = data.orderNos.join(",");
            let refNoarr = [];
            // console.log(data.datalist,'datalistdatalist')
            this.datalist2 = data.datalist.map((item) => {
                if (item.refNo != null) {
                    refNoarr.push(item.refNo);
                }
                return {
                    poRequistionOrderId: item.poRequistionOrderId,
                    poRequistionOrderItemId: item.poRequistionOrderItemId,
                    poRequisitionOrderNo: item.poRequisitionOrderNo,
                    productId: item.productId,
                    erpsku: item.erpsku,
                    // canprice:item.price,
                    price: item.supplierProductPrice,
                    quantity: item.buyquantity,
                    lineId: item.lineId,
                    remark: item.remark,
                    promiseDeliveryDate: item.expectedNeedDate,
                    // productId:item.productId
                };
            });
            // console.log(this.datalist2)
            // 计算预计交货时间
            let date = this.datalist2[0].promiseDeliveryDate;
            this.datalist2.map((item) => {
                // if (this.datalist2.length > 1) {
                let oldDate = new Date(date).getTime();
                let ratherDate = new Date(item.promiseDeliveryDate).getTime();
                if (ratherDate > oldDate) {
                    date = item.promiseDeliveryDate;
                }
                // }
            });
            // this.formData.promiseDeliveryDate = date;

            // console.log(refNoarr)
            let refNostr = refNoarr.join(",");
            this.formData.refNo = refNostr;
            this.formData.inboundRefNo = data.datalist[0].refNo;
            // this.formData.lineId = data.datalist[0].lineId
            this.getallnumber();
            this.handle = {};
        },
        async submit(typra) {
            const valid = await this.$refs.applicateform.validate();
            if (!valid) return;

            if (
                this.formData.paymentType == "payment" ||
                this.formData.paymentType == "fk"
            ) {
                // if (
                //     this.formData.paymentDay === null ||
                //     this.formData.paymentDay === undefined ||
                //     this.formData.paymentDay === ""
                // ) {
                //     this.$VMessage.error("付款账期必须填写！");
                //     return;
                // }
                if (!this.formData.poPurchaserId) {
                    this.$VMessage.error(
                        this.$t("boss.purchase.purchaser_must", {
                            defaultValue: "采购方必须填写！",
                        })
                    );
                    return;
                }
                if (
                    this.poOrderFk.exchangeRate &&
                    this.poOrderFk.exchangeRate < 1
                ) {
                    this.$VMessage.error(
                        this.$t("boss.purchase.exchange_rate", {
                            defaultValue: "汇率填写必须大于0",
                        })
                    );
                    return;
                }
            }
            if (this.purchaseList.length > 0) {
                this.poOrderFk.purchaseContractMeta = JSON.stringify({
                    items: this.purchaseList,
                    opAt: this.purchaseList[0].opAt,
                    organizationId: global.SYSID,
                });
            }
            if (this.exportList.length > 0) {
                this.poOrderFk.exportContractMeta = JSON.stringify({
                    items: this.exportList,
                    opAt: this.exportList[0].opAt,
                    organizationId: global.SYSID,
                });
            }
            if (this.$refs.fkform) {
                const valid2 = await this.$refs.fkform.validate();
                if (!valid2) return;
                if (
                    this.purchaseList.length === 0 ||
                    this.exportList.length === 0
                ) {
                    return this.$VMessage.error(
                        this.$t("boss.purchase.purchase_and_export", {
                            defaultValue: "请上传采购合同和外销合同",
                        })
                    );
                }
                this.formData.poOrderFk = this.poOrderFk;
            }
            this.formData.poOrderItem = this.datalist2;
            this.formData.amount = this.allamount;
            // console.log(this.datalist2)
            // console.log(this.formData.expectedReceiveWarehouseCode)
            if (
                this.formData.expectedReceiveWarehouseCode &&
                this.formData.expectedReceiveWarehouseCode != ""
            ) {
                let warehouseitem =
                    this.ajaxFBBFilterDisabledAllWarehouse.filter((item) => {
                        return (
                            item.attach.code ==
                            this.formData.expectedReceiveWarehouseCode
                        );
                    });

                this.formData.expectedReceiveWarehouseId =
                    warehouseitem[0].value;
                if (warehouseitem[0].attach.warehouseType !== 4) {
                    this.formData.channelFlag = "";
                }
            } else {
                this.formData.expectedReceiveWarehouseCode = "";
                this.formData.expectedReceiveWarehouseId = "";
            }
            let data = {};
            // 保存并提交
            if (typra == "submit") {
                data = {
                    orgId: global.SYSID,
                    ...this.formData,
                    paymentTermId: this.paymentItem.id
                        ? this.paymentItem.id
                        : "",
                    orderStatus: typra,
                };
                let requestData = {
                    orgId: global.SYSID,
                    ...data,
                    meta: JSON.stringify({
                        items: this.docList,
                        opAt: this.docList[0] ? this.docList[0].attachOpAt : "",
                        organizationId: global.SYSID,
                    }),
                    poOrderItem: this.datalist2,
                };
                let isFK =
                    this.formData.paymentType === "fk" ||
                    this.formData.paymentType == "payment";
                this.modalProps = {
                    show: true,
                    alert: "error",
                    title: this.$t("boss.purchase.submit", {
                        defaultValue: "提交",
                    }),
                    width: 460,
                    params: requestData,
                    formdata: [
                        {
                            tag: "vTextarea",
                            key: "remark",
                            span: 24,
                            label: this.$t("boss.purchase.reason_remark", {
                                defaultValue: "备注原因",
                            }),
                            labelWidth: 150,
                            required: false,
                        },
                        {
                            tag: "vCheckbox",
                            key: "dingProcessEnable",
                            show: global.SYSID == 1,
                            default: isFK,
                            span: 24,
                            label: this.$t("boss.purchase.submit_Ding_Talk", {
                                defaultValue: "同时提交钉钉申请流程",
                            }),
                            labelWidth: 150,
                            required: false,
                        },
                    ],
                    ajaxRequest: HttpSaveOrderOne,
                    interceptRequest: (params) => {
                        console.log(params);
                        params.dingProcessEnable = params.dingProcessEnable
                            ? 1
                            : 0;
                        // return null;
                        return params;
                    },
                };
            }
            // 保存为草稿
            else {
                data = {
                    orgId: global.SYSID,
                    ...this.formData,
                    paymentTermId: this.paymentItem.id
                        ? this.paymentItem.id
                        : "",
                };
                let requestData = {
                    orgId: global.SYSID,
                    ...data,
                    meta: JSON.stringify({
                        items: this.docList,
                        opAt: this.docList[0] ? this.docList[0].attachOpAt : "",
                        organizationId: global.SYSID,
                    }),
                    poOrderItem: this.datalist2,
                };
                this.loading = true;

                HttpSaveOrderOne(requestData).then(
                    (res) => {
                        this.loading = false;
                        this.$Message.success(res.message);
                        this.cancel();
                    },
                    (err) => {
                        this.loading = false;
                        this.errorMessage(err.message);
                    }
                );
            }
        },
        remove(index, useId) {
            // 新增时删除附件用另外的接口
            if (this.type === "add") {
                HttpDelAttachNew({
                    id: useId ? index : this.docList[index].attachId,
                }).then(
                    (res) => {
                        if (!useId) {
                            this.docList.splice(index, 1);
                            this.$VMessage.success(res.message);
                        }
                    },
                    (err) => {
                        if (!useId) {
                            this.$VMessage.error({
                                content: err.message,
                                duration: 30,
                                closable: true,
                            });
                        }
                    }
                );
            }
            // 编辑
            else {
                HttpDelAttach({
                    id: this.id || 0,
                    attachId: useId ? index : this.docList[index].attachId,
                }).then(
                    (res) => {
                        if (!useId) {
                            this.docList.splice(index, 1);
                            this.$VMessage.success(res.message);
                        }
                    },
                    (err) => {
                        if (!useId) {
                            this.$VMessage.error({
                                content: err.message,
                                duration: 30,
                                closable: true,
                            });
                        }
                    }
                );
            }
        },
        remove1(index, attachMentId) {
            this.datalist1.splice(index, 1);
            HttpDeleteOrderFile({
                attachMentId: attachMentId,
            }).then(
                (res) => {
                    this.$VMessage.success(res.message);
                },
                (err) => {
                    this.$VMessage.error(res.message);
                }
            );
            // console.log(4545454)
        },
        remove2(index) {
            this.datalist2.splice(index, 1);
            this.getallnumber();
            // console.log(4545454)
        },
        cancel() {
            this.$router.push({
                name: "purchaseOrderList",
            });
        },
        // 点击上传附件之后的操作
        aaasuccess(res) {
            let arrtable = res.data;
            let flagArr = [];

            // erpsku去重
            let tempArr = arrtable.map((item) => {
                return item.erpsku;
            });
            let tempSet = new Set();
            tempArr.map((item) => {
                tempSet.add(item);
            });
            let result = Array.from(tempSet);
            for (let x = 0; x < result.length; x++) {
                for (let y = 0; y < arrtable.length; y++) {
                    if (!result[x].erpsku) {
                        if (result[x] === arrtable[y].erpsku) {
                            // 初始化，改变了数组数据结构
                            if (result[x].quantity === undefined) {
                                result[x] = arrtable[y];
                            } else {
                                result[x].quantity += arrtable[y].quantity;
                            }
                        }
                    } else {
                        if (result[x].erpsku === arrtable[y].erpsku) {
                            result[x].quantity += arrtable[y].quantity;
                        }
                    }
                }
            }
            this.datalist2.push(...result);

            this.getallnumber();
            this.cancelUpload();
        },
        cancelUpload() {
            this.operate.show = false;
        },
    },
    filters: {
        transferText(val, textKey, list = [], key = "id") {
            let text = "";
            list.forEach((item) => {
                if (item[key] === val) {
                    text = item[textKey];
                }
            });
            return text;
        },
    },
};
</script>
